<template>
  <div>
    <div v-show="!loadding">
      <div class="section section3">
        <div class="content content--canvas">
          <div class="banner">
            <div class="banner-logo">
              <img src="../../assets/imgs/logo-zhiyun2.png" alt="" />
            </div>
            <h2>健康出行</h2>
            <div class="select">
              您想去哪:
              <div @click="show = true">
                {{ areaList.province_list[provinceCode]
                }}<van-icon name="arrow-down" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="section1" id="main">
          <div @click="show = true" class="weizhi">
            所在位置: {{ areaList.province_list[provinceCode]
            }}<van-icon name="arrow-down" />
          </div>
          <div class="h1">
            疫情实时动态
            <div class="logo">
              <img src="../../assets/imgs/logo-zhiyun2.png" alt="" />
            </div>
          </div>
          <div class="global">
            <div class="hudong" v-if="provinceCode != 100000">
              {{ aiInfo }}
            </div>

            <div class="txt1">
              <p v-if="provinceInfo">
                {{ provinceInfo.provinceName }}：
                <span v-if="provinceInfo.confirmedCount">
                  确诊 {{ provinceInfo.confirmedCount }} 例
                </span>
              </p>
              <p>{{ data.globalData.countRemark }}</p>

              <ul class="city" v-if="provinceCode == 100000">
                <li v-for="item in data.List" :key="item.id">
                  <van-icon name="stop" />{{ item.provinceName }} 确诊
                  {{ item.confirmedCount }} 例
                </li>
              </ul>
            </div>
            <!-- <ul class="txt2">
            <li>
              <van-icon name="warning" />病毒传染源:
              {{ data.globalData.infectSource }}
            </li>
            <li>
              <van-icon name="warning" />传播途径:{{ data.globalData.passWay }}
            </li>
            <li><van-icon name="warning" />{{ data.globalData.summary }}</li>
          </ul> -->
            <p class="txt3">
              --截止{{
                data.globalData.modifyTime | parseDate("yyyy-MM-dd HH:mm")
              }}统计
            </p>
          </div>
        </div>
        <!-- 
      <div class="section1" v-if="provinceCode == 100000">
        <h1 class="header"><span>疫情地图</span></h1>
        <div class="map">
          <img :src="data.globalData.imgUrl" alt="" />
          <ul class="city">
            <li v-for="item in data.List" :key="item.id">
              <van-icon name="stop" />{{ item.provinceName }} {{ item.tags }}
            </li>
          </ul>
        </div>
      </div> -->

        <div class="section1">
          <div class="news">
            <h1 class="header">
              <span>区域资讯-{{ areaList.province_list[provinceCode] }}</span>
            </h1>
            <div
              class="news-item"
              v-for="(item, index) in provinceNews"
              :key="item.title"
            >
              <div class="news-item-left">
                <span class="news-item-time"
                  ><span style="font-size: 10px; color: rgb(153, 153, 153);">{{
                    item.pubDate | parseDate("MM-dd HH:mm")
                  }}</span></span
                ><span class="news-item-dot"><van-icon name="star"/></span
                ><span class="news-item-line"></span>
              </div>
              <div class="news-item-right" @click="chakan(item.sourceUrl)">
                <p class="news-item-title">
                  <i v-if="index < 3">最新</i>{{ item.title }}
                </p>
                <p class="news-item-content">
                  {{ item.summary }}
                </p>
                <p class="news-item-from">信息来源：{{ item.infoSource }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="section1">
          <h1 class="header"><span>知识库</span></h1>
          <div class="knowledge">
            <p>
              <router-link :to="{ name: 'tielu' }"
                >春节回家,如何避开武汉</router-link
              >
            </p>

            <p>
              <router-link :to="{ name: 'piao' }"
                >交通运输部门免收到达离开武汉的退票手续费</router-link
              >
            </p>

            <p>
              <router-link :to="{ name: 'kouzhao' }"
                >口罩怎么选？病毒怎么防？</router-link
              >
            </p>

            <p>
              <a href="https://mp.weixin.qq.com/s/5MhV1AOPu_DAMiAn4buPTw"
                >勤洗手、戴口罩，预防新型冠状病毒感染肺炎【健康专栏第二期】</a
              >
            </p>
          </div>
        </div>

        <div class="section1 section1-img">
          <h1 class="header"><span>预防手册</span></h1>
          <div class="img-box">
            <!-- <img
          src="//n.sinaimg.cn/news/crawl/300/w550h550/20200121/5e09-innckce6061031.jpg"
          alt=""
        />
        <img
          src="//n.sinaimg.cn/news/crawl/300/w550h550/20200121/635f-innckce6061072.jpg"
          alt=""
        />
        <img
          src="//n.sinaimg.cn/news/crawl/300/w550h550/20200121/9570-innckce6061105.jpg"
          alt=""
        />
        <img
          src="//n.sinaimg.cn/news/crawl/300/w550h550/20200121/1e47-innckce6060276.jpg"
          alt=""
        />
        <img
          src="//n.sinaimg.cn/news/crawl/300/w550h550/20200121/850e-innckce6060382.jpg"
          alt=""
        />
        <img
          src="//n.sinaimg.cn/news/crawl/300/w550h550/20200121/d8f9-innckce6060401.jpg"
          alt=""
        />
        <img
          src="//n.sinaimg.cn/news/crawl/300/w550h550/20200121/85dd-innckce6060442.jpg"
          alt=""
        />
        <img
          src="//n.sinaimg.cn/news/crawl/300/w550h550/20200121/830d-innckce6060492.jpg"
          alt=""
        />
        <img
          src="//n.sinaimg.cn/news/crawl/300/w550h550/20200121/7825-innckce6060543.jpg"
          alt=""
        />
        <img
          src="//n.sinaimg.cn/news/crawl/300/w550h550/20200121/97e9-innckce6060588.jpg"
          alt=""
        /> -->
            <img
              src="//5b0988e595225.cdn.sohucs.com/images/20200118/6de8915f330145c78dfa760254f2bab6.jpeg"
              alt=""
            />

            <img
              src="//5b0988e595225.cdn.sohucs.com/images/20200118/a96db5a3c7db47fa8068a78f29cc28c9.jpeg"
              alt=""
            />

            <img
              src="//5b0988e595225.cdn.sohucs.com/images/20200118/5f9ec0b9ece84f6193bf8aa8d82de6b7.jpeg"
              alt=""
            />

            <img
              src="//5b0988e595225.cdn.sohucs.com/images/20200118/7652b171409e420cb75c8f24134a4d63.jpeg"
              alt=""
            />
          </div>
        </div>
      </div>

      <van-popup v-model="show" position="bottom"
        ><van-area
          @confirm="handleAreaChange"
          @cancel="show = false"
          :area-list="areaList"
          :columns-num="1"
          title="所在省份"
      /></van-popup>
    </div>
    <div v-if="loadding">
      <div class="loading">
        <img src="../../assets/imgs/loading.gif" alt="" />
      </div>
    </div>
  </div>

  <!-- <div>
    <div class="banner">
      <h3>肺炎疫情实时动态监控</h3>

      <p>全国：确诊 324 例 疑似 163 例 治愈 25 例 死亡 6 例</p>
      <p>--截止2020-01-22 09:44统计</p>
    </div>

    <div class="map"></div>

    

    <div>
      <h3>防疫知识库</h3>

      
    </div>

    
  </div> -->
</template>

<script>
import axios from "axios";
export default {
  mounted() {
    try {
      this.$adapt.setShareConfig({
        link: window.location.herf,
        title: "健康出行-智云健康",
        desc: "关注肺炎疫情实时动态 健康出行 远离疾病",
        content: "关注肺炎疫情实时动态 健康出行 远离疾病",
        imageUrl: window.location.origin + "/collection/wuhan/dist/img/logo.png"
      });

      if (document.querySelector(".content--canvas")) {
        setup();
      } else {
        setTimeout(() => {
          if (document.querySelector(".content--canvas")) {
            setup();
          }
        }, 2500);
      }

      const cid = returnCitySN["cid"];
      const cip = returnCitySN["cip"];
      if (/\d\d\d/.test(cid)) {
        this.provinceCode = Number(
          ("" + cid).replace(/(\d\d)\d\d\d\d/, "$10000")
        );
      } else {
        this.provinceCode = 100000;
      }

      this.fetchData();
    } catch (error) {
      console.log(error);
    }
  },
  computed: {
    provinceId() {
      return this.provinceCode / 10000;
    },
    provinceNews() {
      if (this.provinceCode == 100000) {
        return this.data.Timeline;
      }
      return this.data.Timeline.filter(
        item => Number(item.provinceId) == this.provinceId
      );
    },
    provinceInfo() {
      const info = this.data.List.find(
        item => item.provinceId == this.provinceId
      );
      return info;
    },
    aiInfo() {
      const info = this.provinceInfo;

      if (!info) {
        return `恭喜您,您的目标区域(${
          this.areaList.province_list[this.provinceCode]
        })暂无疫情病例,可放心出行 `;
      }

      if (this.provinceCode == 420000) {
        return `您的目标区域(${
          this.areaList.province_list[this.provinceCode]
        })疫情非常严重,建议您取消行程`;
      }

      if (/确诊 \d\d\d/.test(info.tags)) {
        return `您的目标区域(${
          this.areaList.province_list[this.provinceCode]
        })疫情十分严重,出行请做好防护措施,尽量不要去人员聚集地`;
      }

      if (/确诊 \d\d/.test(info.tags)) {
        return `您的目标区域(${
          this.areaList.province_list[this.provinceCode]
        })疫情比较严重,出行请做好防护措施,尽量不要去人员聚集地`;
      }

      if (/确诊/.test(info.tags)) {
        return `您的目标区域(${
          this.areaList.province_list[this.provinceCode]
        })已有确诊病例,出行请做好防护措施`;
      }

      return `您的目标区域(${
        this.areaList.province_list[this.provinceCode]
      })暂无确诊病例,但有疑似病例,出行请做好防护措施`;
    }
  },
  data() {
    return {
      options: {
        sectionsColor: ["#000", "#fff"],
        scrollOverflow: true
      },
      loadding: true,
      data: {
        List: [],
        Timeline: [],
        globalData: {}
      },
      show: false,
      provinceCode: 420000,
      areaList: {
        province_list: {
          100000: "全国",
          110000: "北京市",
          120000: "天津市",
          130000: "河北省",
          140000: "山西省",
          150000: "内蒙古自治区",
          210000: "辽宁省",
          220000: "吉林省",
          230000: "黑龙江省",
          310000: "上海市",
          320000: "江苏省",
          330000: "浙江省",
          340000: "安徽省",
          350000: "福建省",
          360000: "江西省",
          370000: "山东省",
          410000: "河南省",
          420000: "湖北省",
          430000: "湖南省",
          440000: "广东省",
          450000: "广西壮族自治区",
          460000: "海南省",
          500000: "重庆市",
          510000: "四川省",
          520000: "贵州省",
          530000: "云南省",
          540000: "西藏自治区",
          610000: "陕西省",
          620000: "甘肃省",
          630000: "青海省",
          640000: "宁夏回族自治区",
          650000: "新疆维吾尔自治区",
          680000: "台湾省",
          660000: "香港特别行政区",
          670000: "澳门特别行政区"
        }
      }
    };
  },
  methods: {
    toShop(code) {
      this.$adapt.open(`hybird://shop/index.html#detail/${code}`);
    },
    handleAreaChange(info) {
      window.scrollTo({
        top: document.body.clientHeight,
        behavior: "smooth"
      });
      this.provinceCode = info[0].code;
      this.show = false;
    },
    chakan(url) {
      window.location.href = url;
    },
    fetchData() {
      const oldData = window.localStorage.getItem("wuhan");
      if (oldData) {
        this.data = JSON.parse(window.localStorage.getItem("wuhan"));
        this.loadding = false;
      } else {
        this.data = {
          List: [
            {
              id: 1,
              createTime: 1579538652000,
              modifyTime: 1579704518000,
              tags: "确诊 444 例，疑似病例数待确认，治愈 28 例，死亡 17 例",
              countryType: 1,
              provinceId: "42",
              provinceName: "湖北省",
              provinceShortName: "湖北",
              cityName: "",
              confirmedCount: 549,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "疑似数据待确认，治愈 28 例，死亡 24 例",
              sort: 1,
              operator: "zhanglifeng"
            },
            {
              id: 3,
              createTime: 1579542174000,
              modifyTime: 1579773067000,
              tags: "确诊 32 例，疑似 1 例，治愈 2 例",
              countryType: 1,
              provinceId: "44",
              provinceName: "广东省",
              provinceShortName: "广东",
              cityName: "",
              confirmedCount: 53,
              suspectedCount: 0,
              curedCount: 2,
              deadCount: 0,
              comment: "治愈 2 例",
              sort: 2,
              operator: "zhanglifeng"
            },
            {
              id: 10,
              createTime: 1579546399000,
              modifyTime: 1579759106000,
              tags: "确诊 27 例",
              countryType: 1,
              provinceId: "33",
              provinceName: "浙江省",
              provinceShortName: "浙江",
              cityName: "",
              confirmedCount: 43,
              suspectedCount: 0,
              curedCount: 1,
              deadCount: 0,
              comment: "治愈 1 例",
              sort: 3,
              operator: "heyanan"
            },
            {
              id: 2,
              createTime: 1579542158000,
              modifyTime: 1579774464000,
              tags: "确诊 22 例 ",
              countryType: 1,
              provinceId: "11",
              provinceName: "北京市",
              provinceShortName: "北京",
              cityName: "",
              confirmedCount: 26,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 4,
              operator: "zhanglifeng"
            },
            {
              id: 6,
              createTime: 1579542231000,
              modifyTime: 1579740884000,
              tags: "确诊 16 例，疑似 22 例",
              countryType: 1,
              provinceId: "31",
              provinceName: "上海市",
              provinceShortName: "上海",
              cityName: "",
              confirmedCount: 20,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 5,
              operator: "zhanglifeng"
            },
            {
              id: 27,
              createTime: 1579623404000,
              modifyTime: 1579751736000,
              tags: "确诊 24 例",
              countryType: 1,
              provinceId: "43",
              provinceName: "湖南省",
              provinceShortName: "湖南",
              cityName: "",
              confirmedCount: 24,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 6,
              operator: "huanshi"
            },
            {
              id: 14,
              createTime: 1579598038000,
              modifyTime: 1579754921000,
              tags: "确诊 9 例，疑似 4 例",
              countryType: 1,
              provinceId: "34",
              provinceName: "安徽省",
              provinceShortName: "安徽",
              cityName: "",
              confirmedCount: 15,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 7,
              operator: "zyyun"
            },
            {
              id: 22,
              createTime: 1579612635000,
              modifyTime: 1579754889000,
              tags: "确诊 9 例",
              countryType: 1,
              provinceId: "50",
              provinceName: "重庆市",
              provinceShortName: "重庆",
              cityName: "",
              confirmedCount: 27,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 8,
              operator: "huanshi"
            },
            {
              id: 4,
              createTime: 1579542193000,
              modifyTime: 1579747776000,
              tags: "确诊 8 例，疑似 2 例",
              countryType: 1,
              provinceId: "51",
              provinceName: "四川省",
              provinceShortName: "四川",
              cityName: "",
              confirmedCount: 15,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 9,
              operator: "zhanglifeng"
            },
            {
              id: 8,
              createTime: 1579542291000,
              modifyTime: 1579747746000,
              tags: "确诊 6 例， 疑似 2 例",
              countryType: 1,
              provinceId: "37",
              provinceName: "山东省",
              provinceShortName: "山东",
              cityName: "",
              confirmedCount: 9,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 10,
              operator: "zhanglifeng"
            },
            {
              id: 7,
              createTime: 1579542254000,
              modifyTime: 1579738494000,
              tags: "确诊 5 例",
              countryType: 1,
              provinceId: "45",
              provinceName: "广西壮族自治区",
              provinceShortName: "广西",
              cityName: "",
              confirmedCount: 13,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 11,
              operator: "zhanglifeng"
            },
            {
              id: 32,
              createTime: 1579688286000,
              modifyTime: 1579771253000,
              tags: "确诊 5 例 疑似 2 例",
              countryType: 1,
              provinceId: "35",
              provinceName: "福建省",
              provinceShortName: "福建",
              cityName: "",
              confirmedCount: 5,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 12,
              operator: "dengyuguo"
            },
            {
              id: 34,
              createTime: 1579709672000,
              modifyTime: 1579786691000,
              tags: "确诊 5 例",
              countryType: 1,
              provinceId: "32",
              provinceName: "江苏省",
              provinceShortName: "江苏",
              cityName: "",
              confirmedCount: 9,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 13,
              operator: "huanshi"
            },
            {
              id: 21,
              createTime: 1579607817000,
              modifyTime: 1579700317000,
              tags: "确诊 5 例",
              countryType: 1,
              provinceId: "41",
              provinceName: "河南省",
              provinceShortName: "河南",
              cityName: "",
              confirmedCount: 9,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 14,
              operator: "huanshi"
            },
            {
              id: 15,
              createTime: 1579598057000,
              modifyTime: 1579768905000,
              tags: "确诊 5 例，疑似 32 例",
              countryType: 1,
              provinceId: "46",
              provinceName: "海南省",
              provinceShortName: "海南",
              cityName: "",
              confirmedCount: 8,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 15,
              operator: "zyyun"
            },
            {
              id: 20,
              createTime: 1579604600000,
              modifyTime: 1579700289000,
              tags: "确诊 4 例",
              countryType: 1,
              provinceId: "12",
              provinceName: "天津市",
              provinceShortName: "天津",
              cityName: "",
              confirmedCount: 5,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 16,
              operator: "zyyun"
            },
            {
              id: 18,
              createTime: 1579598380000,
              modifyTime: 1579797267000,
              tags: "确诊 7 例",
              countryType: 1,
              provinceId: "36",
              provinceName: "江西省",
              provinceShortName: "江西",
              cityName: "",
              confirmedCount: 7,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 17,
              operator: "zyyun"
            },
            {
              id: 35,
              createTime: 1579745445000,
              modifyTime: 1579774432000,
              tags: "确诊 3 例 疑似 1 例",
              countryType: 1,
              provinceId: "61",
              provinceName: "陕西省",
              provinceShortName: "陕西",
              cityName: "",
              confirmedCount: 3,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 18,
              operator: "zyyun"
            },
            {
              id: 12,
              createTime: 1579588572000,
              modifyTime: 1579754969000,
              tags: "确诊 3 例",
              countryType: 1,
              provinceId: "52",
              provinceName: "贵州省",
              provinceShortName: "贵州",
              cityName: "",
              confirmedCount: 3,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 19,
              operator: "caoyang"
            },
            {
              id: 29,
              createTime: 1579656427000,
              modifyTime: 1579751654000,
              tags: "确诊 3 例",
              countryType: 1,
              provinceId: "21",
              provinceName: "辽宁省",
              provinceShortName: "辽宁",
              cityName: "",
              confirmedCount: 3,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 20,
              operator: "caoyang"
            },
            {
              id: 25,
              createTime: 1579617215000,
              modifyTime: 1579791987000,
              tags: "确诊 2 例 疑似 65 例",
              countryType: 1,
              provinceId: "66",
              provinceName: "香港",
              provinceShortName: "香港",
              cityName: "",
              confirmedCount: 2,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 21,
              operator: "huanshi"
            },
            {
              id: 26,
              createTime: 1579621178000,
              modifyTime: 1579777116000,
              tags: "确诊 2 例",
              countryType: 1,
              provinceId: "23",
              provinceName: "黑龙江省",
              provinceShortName: "黑龙江",
              cityName: "",
              confirmedCount: 4,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "绥化 死亡 1 例",
              sort: 22,
              operator: "huanshi"
            },
            {
              id: 30,
              createTime: 1579663914000,
              modifyTime: 1579745548000,
              tags: "确诊 2 例",
              countryType: 1,
              provinceId: "67",
              provinceName: "澳门",
              provinceShortName: "澳门",
              cityName: "",
              confirmedCount: 2,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 23,
              operator: "zyyun"
            },
            {
              id: 38,
              createTime: 1579774516000,
              modifyTime: 1579774516000,
              tags: "确诊 2 例 ",
              countryType: 1,
              provinceId: "65",
              provinceName: "新疆维吾尔自治区",
              provinceShortName: "新疆",
              cityName: "",
              confirmedCount: 2,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 24,
              operator: "lvdong"
            },
            {
              id: 37,
              createTime: 1579757757000,
              modifyTime: 1579791575000,
              tags: "确诊 2 例",
              countryType: 1,
              provinceId: "62",
              provinceName: "甘肃省",
              provinceShortName: "甘肃",
              cityName: "",
              confirmedCount: 2,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 25,
              operator: "huanshi"
            },
            {
              id: 5,
              createTime: 1579542213000,
              modifyTime: 1579796948000,
              tags: "确诊 2 例",
              countryType: 1,
              provinceId: "53",
              provinceName: "云南省",
              provinceShortName: "云南",
              cityName: "",
              confirmedCount: 2,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 26,
              operator: "zhanglifeng"
            },
            {
              id: 24,
              createTime: 1579617167000,
              modifyTime: 1579700359000,
              tags: "确诊 1 例",
              countryType: 1,
              provinceId: "68",
              provinceName: "台湾",
              provinceShortName: "台湾",
              cityName: "",
              confirmedCount: 1,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 27,
              operator: "huanshi"
            },
            {
              id: 31,
              createTime: 1579682845000,
              modifyTime: 1579700369000,
              tags: "确诊 1 例",
              countryType: 1,
              provinceId: "14",
              provinceName: "山西省",
              provinceShortName: "山西",
              cityName: "",
              confirmedCount: 1,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 28,
              operator: "lvdong"
            },
            {
              id: 17,
              createTime: 1579598339000,
              modifyTime: 1579751679000,
              tags: "确诊 1 例",
              countryType: 1,
              provinceId: "22",
              provinceName: "吉林省",
              provinceShortName: "吉林",
              cityName: "",
              confirmedCount: 3,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 29,
              operator: "zyyun"
            },
            {
              id: 33,
              createTime: 1579705215000,
              modifyTime: 1579797215000,
              tags: "确诊 1 例，死亡 1 例",
              countryType: 1,
              provinceId: "13",
              provinceName: "河北省",
              provinceShortName: "河北",
              cityName: "",
              confirmedCount: 2,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 1,
              comment: "沧州 死亡1 例",
              sort: 30,
              operator: "dongyang"
            },
            {
              id: 16,
              createTime: 1579598101000,
              modifyTime: 1579700276000,
              tags: "确诊 1 例",
              countryType: 1,
              provinceId: "64",
              provinceName: "宁夏回族自治区",
              provinceShortName: "宁夏",
              cityName: "",
              confirmedCount: 1,
              suspectedCount: 0,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 31,
              operator: "zyyun"
            },
            {
              id: 36,
              createTime: 1579754908000,
              modifyTime: 1579754908000,
              tags: "疑似 1 例",
              countryType: 1,
              provinceId: "15",
              provinceName: "内蒙古自治区",
              provinceShortName: "内蒙古",
              cityName: "",
              confirmedCount: 0,
              suspectedCount: 1,
              curedCount: 0,
              deadCount: 0,
              comment: "",
              sort: 32,
              operator: "huanshi"
            }
          ],
          globalData: {
            id: 1,
            createTime: 1579537899000,
            modifyTime: 1579834121000,
            infectSource: "野生动物，可能中华菊头蝠",
            passWay: "未完全掌握，存在人传人、医务人员感染、一定范围社区传播",
            imgUrl:
              "https://img1.dxycdn.com/2020/0123/733/3392575782185696736-73.jpg",
            dailyPic: "",
            summary: "",
            deleted: false,
            countRemark: "全国 确诊 868 例 疑似 1072 例 治愈 34 例 死亡 26 例",
            virus: "新型冠状病毒 2019-nCoV",
            remark1: "病毒是否变异：存在可能",
            remark2: "疫情是否扩散：是",
            remark3: "",
            remark4: "",
            remark5: ""
          },
          Timeline: [
            {
              id: 135,
              pubDate: 1579794183000,
              pubDateStr: "53分钟前",
              title: "证据确凿！新冠肺炎病毒来自野生动物",
              summary:
                "国家卫健委专家高福表示，病毒不光在感染的人体内看到了，在华南海鲜市场非法销售野生动物的这些摊位也分离到了病毒，这应该说是证据确凿。",
              infoSource: "人民日报",
              sourceUrl: "http://m.weibo.cn/2803301701/4464039793147643",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579794245000,
              modifyTime: 1579794245000
            },
            {
              id: 136,
              pubDate: 1579792394000,
              pubDateStr: "1小时前",
              title: "武汉网约出租停运，巡游出租单双号限行",
              summary:
                "武汉市新冠肺炎防控指挥部通告：自 2020 年 1 月 24 日 12 时起，武汉全市网约出租车停止运营；巡游出租车实行单双号限行。恢复时间另行通告。",
              infoSource: "人民日报微博",
              sourceUrl: "http://m.weibo.cn/2803301701/4464035300562048",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579794759000,
              modifyTime: 1579794759000
            },
            {
              id: 134,
              pubDate: 1579790246000,
              pubDateStr: "1小时前",
              title: "甘肃省确认2例新型冠状病毒感染的肺炎确诊病例",
              summary:
                "1月23日，根据国家卫生健康委关于各省首例新型冠状病毒感染的肺炎最新确诊程序，以及《新型冠状病毒感染的肺炎诊疗方案（试行第三版）》规定，甘肃省确认2例新型冠状病毒感染的肺炎确诊病例。  甘肃省首例疑似病例吴某某，经中国疾控中心实验室复核检测，呈新型冠状病毒核酸阳性，结合患者临床表现、流行病学史，确认为新型冠状病毒感染的肺炎确诊病例。",
              infoSource: "人民日报",
              sourceUrl: "https://wap.peopleapp.com/article/5071498/4965957",
              provinceId: "62",
              provinceName: "甘肃省",
              createTime: 1579791169000,
              modifyTime: 1579791169000
            },
            {
              id: 133,
              pubDate: 1579789476000,
              pubDateStr: "2小时前",
              title: "湖北赤壁公交客运暂停运营",
              summary:
                "1月23日，赤壁市新型冠状病毒感染的肺炎防控指挥部发布通告：为全力做好新型冠状病毒感染的肺炎疫情防控工作，有效切断病毒传播途径，坚决遏制疫情蔓延势头，确保人民群众生命安全和身体健康，自2020年1月24日0时起，赤壁市城市公交、农村客运、省县级客运暂停运营，恢复时间另行通告。",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqRwg0asp?from=page_1002062803301701_profile&wvr=6&mod=weibotime&type=comment#_rnd1579789568714",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579789697000,
              modifyTime: 1579789697000
            },
            {
              id: 132,
              pubDate: 1579788549000,
              pubDateStr: "2小时前",
              title: "湖北仙桃新冠肺炎疫情防控指挥部1号令",
              summary:
                "①仙桃启动突发公共卫生事件二级响应；②市内所有公交车、渡船，包括农村客运车全部停运；③市内高速出口、火车站体温检测排查点全部设置到位；④取消一切群体性宴席集会，包括群众自发组织的聚会；⑤取消全市农(集)贸市场活禽交易；关闭全市所有游乐场所、娱乐场所、室内运动场所（包括电影院、卡拉OK、书店、网吧等）。",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqRqTgOEe?from=page_1002062803301701_profile&wvr=6&mod=weibotime&type=comment#_rnd1579788703283",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579788757000,
              modifyTime: 1579788757000
            },
            {
              id: 130,
              pubDate: 1579788099000,
              pubDateStr: "2小时前",
              title: "民航机票免收退票费",
              summary:
                "为全力做好新型冠状病毒肺炎疫情联防联控工作，民航局要求，自2020年1月24日0时起，此前已购买民航机票的旅客自愿退票的，各航空公司及其客票销售代理机构应免费办理退票，不得收取任何费用。",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2656274875/IqRnAwyjG?from=page_1002062656274875_profile&wvr=6&mod=weibotime&type=comment#_rnd1579788183733",
              provinceId: "11",
              provinceName: "北京市",
              createTime: 1579788306000,
              modifyTime: 1579788306000
            },
            {
              id: 131,
              pubDate: 1579788087000,
              pubDateStr: "2小时前",
              title: "四川派出135人组建第一批援助湖北医疗队",
              summary:
                "根据四川省卫健委的安排，将派出135人组建的第一批援助湖北的医疗队。其中包括四川大学华西医院、省人民医院，川北医学院附属医院、西南医科大学附属医院、省第四人民医院、成都中医药大学附属医院、西南医科大学附属中医医院和省第二中医医院的专家。各医院重点安排呼吸科，感染科，重症医学科或呼吸科重症医学专业的医生。",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqRnp1phi?from=page_1002062803301701_profile&wvr=6&mod=weibotime&type=comment#_rnd1579788480715",
              provinceId: "51",
              provinceName: "四川省",
              createTime: 1579788534000,
              modifyTime: 1579788534000
            },
            {
              id: 128,
              pubDate: 1579785840000,
              pubDateStr: "3小时前",
              title: "江苏新增新型肺炎病例 4 例",
              summary:
                "1月23日0-18时，江苏省报告新型冠状病毒感染的肺炎新增确诊病例4例。其中，南京市2例、连云港市和扬州市各1例，为南京市、连云港市和扬州市首次报告确诊病例。4例病例均有近期武汉旅行史。",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2656274875/IqR8LyMDn?from=page_1002062656274875_profile&wvr=6&mod=weibotime&type=comment#_rnd1579786167508",
              provinceId: "32",
              provinceName: "江苏省",
              createTime: 1579786468000,
              modifyTime: 1579786468000
            },
            {
              id: 129,
              pubDate: 1579785060000,
              pubDateStr: "3小时前",
              title: "新加坡确认首例新型冠状病毒病例",
              summary:
                "新加坡卫生部今晚确认，新加坡确认首例新型冠状病毒病例。患者是一位66岁男子。另有一名53岁女子初步测试结果呈阳性，目前正在等待最终的检测结果。",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2656274875/IqR3d2Gm5?from=page_1002062656274875_profile&wvr=6&mod=weibotime&type=comment#_rnd1579786576906",
              provinceId: "1",
              createTime: 1579786945000,
              modifyTime: 1579786945000
            },
            {
              id: 127,
              pubDate: 1579784307000,
              pubDateStr: "3小时前",
              title: "教育部要求高校做好开学前疫情防控预案",
              summary:
                "1月23日，教育部再发通知，要求教育系统做好新型冠状病毒感染的肺炎疫情防控应急预案工作。要求密切关注疫情发展情况，提前对春季开学有关情况做出科学研判，必要时对学校教学安排及相关工作做出调整。有关高校必须做好开学前疫情防控工作预案。",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqQYfowAq?from=page_1002062803301701_profile&wvr=6&mod=weibotime&type=comment#_rnd1579784552681",
              provinceId: "11",
              provinceName: "北京市",
              createTime: 1579784632000,
              modifyTime: 1579784632000
            },
            {
              id: 126,
              pubDate: 1579783680000,
              pubDateStr: "3小时前",
              title: "广东启动重大突发公共卫生事件一级响应",
              summary:
                "根据《广东省突发公共卫生事件应急预案》，结合我省当前新型冠状病毒感染的肺炎疫情防控形势，省新型冠状病毒感染的肺炎疫情防控工作领导小组决定，启动广东省重大突发公共卫生事件一级响应。",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqQU86jsH?from=page_1002062803301701_profile&wvr=6&mod=weibotime&type=comment#_rnd1579783822682",
              provinceId: "44",
              provinceName: "广东省",
              createTime: 1579783985000,
              modifyTime: 1579783985000
            },
            {
              id: 124,
              pubDate: 1579781440000,
              pubDateStr: "4小时前",
              title: "人社部：医护人员感染新型肺炎应认定工伤",
              summary:
                "人社部、财政部、卫健委今天印发有关人员因履职感染新型肺炎保障通知，明确在新型冠状病毒肺炎预防和救治工作中，医护及相关工作人员因履行工作职责，感染新型冠状病毒肺炎或因感染新型冠状病毒肺炎死亡的，应认定为工伤，依法享受工伤保险待遇。",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqQE5tZla?from=page_1002062803301701_profile&wvr=6&mod=weibotime&type=comment#_rnd1579781604946",
              provinceId: "11",
              provinceName: "北京市",
              createTime: 1579781649000,
              modifyTime: 1579781649000
            },
            {
              id: 123,
              pubDate: 1579780537000,
              pubDateStr: "4小时前",
              title: "武汉文娱场所暂停营业，湖北省A级景区星级饭店活动一律取消",
              summary: "湖北省新冠肺炎防控再升级，湖北省文旅厅提出6条措施",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqQyi8CcR?from=page_1002062803301701_profile&wvr=6&mod=weibotime",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579781016000,
              modifyTime: 1579781016000
            },
            {
              id: 122,
              pubDate: 1579780255000,
              pubDateStr: "4小时前",
              title: "北京取消大型活动",
              summary:
                "北京市文化和旅游局发布：根据市委市政府防控工作领导小组总体部署，即日起，北京市取消包括庙会在内的大型活动。请市民朋友们加强防范，予以支持。随着疫情变化，我们将随时对全市相关活动举办情况进行通报。大型活动取消后，活动主办单位将积极做好相关善后工作。",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqQwkolbL?ref=home&rid=2_0_202_2606538780623294377_0_0_0",
              provinceId: "11",
              provinceName: "北京市",
              createTime: 1579780860000,
              modifyTime: 1579780860000
            },
            {
              id: 121,
              pubDate: 1579779185000,
              pubDateStr: "5小时前",
              title: "武汉新冠肺炎防控指挥部第4号通告",
              summary:
                "武汉慈善总会负责接受捐款和通用物资、红十字会负责接受医用耗材、防护用品等专项物资。当前急需物资包括：医用设备、医疗设备、试剂、药品、防护设备、消洗设备、耗材（口罩需求量较大）等。",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqQpK3Vtc?ref=home&rid=0_0_202_1413096853739001444_0_0_0",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579779538000,
              modifyTime: 1579779538000
            },
            {
              id: 125,
              pubDate: 1579778184000,
              pubDateStr: "5小时前",
              title: "湖北中小学开学确定延期",
              summary:
                "人民日报记者从省教育厅获悉，今年春季湖北省中小学开学确定延期，但具体何时开学有待后续公布。 ​​​",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqQisx7uW?refer_flag=1001030103_&type=comment#_rnd1579781802613",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579782332000,
              modifyTime: 1579782332000
            },
            {
              id: 120,
              pubDate: 1579776932000,
              pubDateStr: "5小时前",
              title: "香港确诊2例新型肺炎病例",
              summary:
                "刚刚，香港电台网站援引香港卫生署消息称，香港2例高度疑似新型冠状病毒感染的肺炎病例被确诊。 ​​​",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqQaBzbk5?ref=home&rid=3_0_202_2606570211193007993_0_0_0",
              provinceId: "66",
              provinceName: "香港",
              createTime: 1579777879000,
              modifyTime: 1579777879000
            },
            {
              id: 119,
              pubDate: 1579776247000,
              pubDateStr: "5小时前",
              title: "襄阳发现新冠肺炎疑似病例31例",
              summary:
                "据襄阳市新型冠状病毒感染的肺炎防控领导小组办公室通报：截至2020年1月22日20:00，襄阳市新增新型冠状病毒感染的肺炎疑似病例28例，累计达到31例（其中襄城区20例，樊城区5例，枣阳市3例，南漳县3例）。襄阳市已按照国家卫健委关于新型冠状病毒感染的肺炎防控工作方案的要求，采取了在当地定点医疗机构隔离诊断救治的措施。同时，对疑似患者迅速开展了流行病学调查，并对其密切接触者实施医学观察。",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqQ5yiMWI?ref=home&rid=1_0_202_2669688664026705533_0_0_0",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579776583000,
              modifyTime: 1579776583000
            },
            {
              id: 118,
              pubDate: 1579773896000,
              pubDateStr: "6小时前",
              title: "新疆确诊2例新型肺炎病例",
              summary:
                "1月23日，新疆维吾尔自治区卫生健康委首次确认全区2例新型冠状病毒感染的肺炎确诊病例。",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2656274875/IqPPzg76l?ref=home&rid=3_0_202_2667274531628325700_0_0_0",
              provinceId: "65",
              provinceName: "新疆维吾尔自治区",
              createTime: 1579774615000,
              modifyTime: 1579774615000
            },
            {
              id: 117,
              pubDate: 1579773397000,
              pubDateStr: "6小时前",
              title: "陕西确诊3例新型肺炎病例",
              summary:
                "1月23日，根据国家卫健委关于各省首例新型冠状病毒感染的肺炎最新确诊程序以及《新型冠状病毒感染的肺炎诊疗方案》（试行第三版）规定，经省级医疗救治专家组会商，来自武汉或与武汉病例有接触并出现发热等呼吸道症状4例患者中，确认3例输入性新型冠状病毒感染的肺炎确诊病例。",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqPMidEzh?from=page_1002062803301701_profile&wvr=6&mod=weibotime",
              provinceId: "61",
              provinceName: "陕西省",
              createTime: 1579774547000,
              modifyTime: 1579774547000
            },
            {
              id: 116,
              pubDate: 1579773248000,
              pubDateStr: "6小时前",
              title: "北京新增8例新型肺炎病例",
              summary:
                "北京市卫健委：截至今日14时北京市新增8例新型冠状病毒感染的肺炎病例，累计病例22人。 ​​​​",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2656274875/IqPL9kMxK?from=page_1002062656274875_profile&wvr=6&mod=weibotime",
              provinceId: "11",
              provinceName: "北京市",
              createTime: 1579773778000,
              modifyTime: 1579773778000
            },
            {
              id: 115,
              pubDate: 1579772083000,
              pubDateStr: "7小时前",
              title: "好消息！深圳两新型肺炎确诊患者出院",
              summary:
                "深圳市第三人民医院通报：截至今天下午四点，深圳市第三人民医院收治的第一批新型冠状病毒感染患者中，有2例确诊的患者已经痊愈出院，1例密切接触者也已经痊愈出院。流程严格按照省、市专家组的会诊后，达到出院的标准。 ​​​",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2656274875/IqPDmef1r?ref=home&rid=1_0_202_2669548356034745105_0_0_0",
              provinceId: "44",
              provinceName: "广东省",
              createTime: 1579773202000,
              modifyTime: 1579773202000
            },
            {
              id: 114,
              pubDate: 1579770706000,
              pubDateStr: "7小时前",
              title: "福建新增1例新型肺炎确诊病例，另新增2例疑似病例",
              summary:
                "今日16时，福建省报告新增输入性新型冠状病毒感染的肺炎1例确诊病例和2例疑似病例。其中：福州市新增1例确诊病例，厦门市新增2例疑似病例。新增患者均为武汉返乡人员，目前患者病情平稳，正在接受隔离治疗，追踪到的密切接触者正在接受医学观察。",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2656274875/IqPu3mldD?ref=home&rid=0_0_202_2632724216972980252_0_0_0",
              provinceId: "35",
              provinceName: "福建省",
              createTime: 1579771384000,
              modifyTime: 1579771384000
            },
            {
              id: 113,
              pubDate: 1579770124000,
              pubDateStr: "7小时前",
              title: "湖北鄂州铁路车站关闭",
              summary:
                "鄂州市新型冠状病毒感染的肺炎疫情防控指挥部：为全力做好新型冠状病毒感染的肺炎疫情防控工作，有效切断病毒传播途径，坚决遏制疫情蔓延势头，确保人民群众生命安全和身体健康，现将有关事项通告如下：自2020年1月23日11:20起，全市铁路车站通道暂时关闭，恢复时间另行通知。",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqPqkikC5?ref=home&rid=0_0_202_1413096458600052330_0_0_0",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579770334000,
              modifyTime: 1579770334000
            },
            {
              id: 112,
              pubDate: 1579769718000,
              pubDateStr: "7小时前",
              title: "湖北黄冈新型冠状病毒感染的肺炎防控工作指挥部通告",
              summary:
                "为全力做好新型冠状病毒感染的肺炎疫情防控工作，有效切断病毒传播途径，坚决遏制疫情蔓延势头，确保人民群众生命安全和身体健康，湖北黄冈新型冠状病毒感染的肺炎防控工作指挥部发布通告。",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqPnwhj3U?ref=home&rid=0_0_202_793502698364441048_0_0_0",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579770180000,
              modifyTime: 1579770180000
            },
            {
              id: 111,
              pubDate: 1579769184000,
              pubDateStr: "7小时前",
              title: "浙江重大公共突发卫生事件一级响应启动",
              summary:
                "今天上午，浙江省政府紧急召开全省新型冠状病毒感染的肺炎疫情防控工作视频会议，根据《浙江省突发公共卫生事件应急预案》，会议决定启动重大公共突发卫生事件一级响应。",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2656274875/IqPjriPxp?ref=home&rid=1_0_202_2669526159643354715_0_0_0",
              provinceId: "33",
              provinceName: "浙江省",
              createTime: 1579769609000,
              modifyTime: 1579769609000
            },
            {
              id: 109,
              pubDate: 1579766261000,
              pubDateStr: "8小时前",
              title: "海南新增1例新型肺炎确诊病例",
              summary:
                "据海南省卫健委通报，截至1月23日7时，海南省新型冠状病毒感染的肺炎新增确诊病例1例。海南省累计报告确诊病例5例，无重症病例、死亡病例和出院病例。确诊病例中，三亚市2例、海口市1例、万宁市1例、临高县1例。目前追踪到密切接触者329人，已解除医学观察0人，尚有329人正在接受医学观察。",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2656274875/IqOZA1ovA?from=page_1002062656274875_profile&wvr=6&mod=weibotime",
              provinceId: "46",
              provinceName: "海南省",
              createTime: 1579769013000,
              modifyTime: 1579769013000
            },
            {
              id: 108,
              pubDate: 1579764329000,
              pubDateStr: "9小时前",
              title: "武汉所有旅游团队一律取消",
              summary:
                "武汉市文化和旅游局今天通报，为遏制新型冠状病毒感染的肺炎疫情蔓延，全市所有旅游团队一律取消。全市所有旅行社企业不得以任何方式推诿，并做好团队取消的后续工作。由于不可抗力不能成行而取消旅游合同的，旅行社和游客均不需要支付违约金，旅行社应退回游客前期所交的预付金。",
              infoSource: "央视新闻",
              sourceUrl: "https://m.weibo.cn/2656274875/4463917416272052",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579766346000,
              modifyTime: 1579766346000
            },
            {
              id: 110,
              pubDate: 1579760885000,
              pubDateStr: "10小时前",
              title: "好消息！温州首例新型肺炎患者基本痊愈",
              summary:
                "根据温州市中心医院的消息，1月22日，温州市诊治专家组会诊，温州首例新型冠状病毒感染的肺炎确诊患者杨某某体温恢复正常已达3天以上，各项生命体征平稳，肺部影像学显示炎症明显吸收，1月18日、1月20日连续两次呼吸道病原核酸检测阴性，已基本痊愈。",
              infoSource: "人民日报",
              sourceUrl: "https://mp.weixin.qq.com/s/SMyWlpFu8K8NQCxptU8V9g",
              provinceId: "33",
              provinceName: "浙江省",
              createTime: 1579769512000,
              modifyTime: 1579769512000
            },
            {
              id: 107,
              pubDate: 1579760731000,
              pubDateStr: "10小时前",
              title: "武汉开通 24 小时电话接收捐赠",
              summary:
                "武汉市新型肺炎防控指挥部通报：为做好社会各界捐赠武汉市抗击疫情的医用耗材、防护用品等物质接收调配工作，现开通 24 小时电话接收社会各界爱心捐赠。武汉市红十字会电话：027-82788599，027-82210181，027-82812604，027-82858499，027-82856122",
              infoSource: "央视新闻",
              sourceUrl: "https://m.weibo.cn/2656274875/4463902358582553",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579763480000,
              modifyTime: 1579763480000
            },
            {
              id: 106,
              pubDate: 1579758717000,
              pubDateStr: "10小时前",
              title: "浙江新增 17 例新型肺炎确诊病例",
              summary:
                "1月22日12时至1月23日12时，浙江省新增新型冠状病毒感染的肺炎确诊病例17例。其中杭州5例、宁波2例、温州2例、绍兴1例、金华1例、衢州1例、台州5例。 ​​​​",
              infoSource: "央视新闻微博",
              sourceUrl: "http://dxys.com/8dHLoV",
              provinceId: "33",
              provinceName: "浙江省",
              createTime: 1579759051000,
              modifyTime: 1579759051000
            },
            {
              id: 105,
              pubDate: 1579758036000,
              pubDateStr: "10小时前",
              title: "黑龙江发现 1 例新型肺炎疑似病例",
              summary:
                "国家卫生健康委确认，黑龙江省大庆市肇州县发现1名新型冠状病毒感染的肺炎疑似病例。目前，黑龙江省共有2例新型冠状病毒感染的肺炎确诊病例。",
              infoSource: "央视新闻微博",
              sourceUrl: "http://dxys.com/aem9vw",
              provinceId: "23",
              provinceName: "黑龙江省",
              createTime: 1579758366000,
              modifyTime: 1579758366000
            },
            {
              id: 103,
              pubDate: 1579757068000,
              pubDateStr: "11小时前",
              title: "甘肃发现首例新型肺炎疑似病例",
              summary:
                "甘肃省卫健委消息，甘肃省发现首例新型冠状病毒感染的肺炎疑似病例。根据病例临床表现、流行病学史、实验室检测结果，判定为新型冠状病毒感染的肺炎疑似病例。",
              infoSource: "央视新闻微博",
              sourceUrl: "http://dxys.com/pxboAu",
              provinceId: "62",
              provinceName: "甘肃省",
              createTime: 1579757955000,
              modifyTime: 1579757955000
            },
            {
              id: 102,
              pubDate: 1579754829000,
              pubDateStr: "11小时前",
              title: "江西新增 1 例新型肺炎确诊病例",
              summary:
                "1月22日0—24时，江西省报告新型冠状病毒感染的肺炎新增确诊病例1例，属重症病例。新增病例为南昌市报告首例确诊病例。截至1月22日24时，江西省累计报告新型冠状病毒感染的肺炎确诊病例3例，其中重症病例2例，死亡病例0例，出院病例0例。",
              infoSource: "央视新闻微博",
              sourceUrl: "http://dxys.com/25jQWV",
              provinceId: "36",
              provinceName: "江西省",
              createTime: 1579755170000,
              modifyTime: 1579755170000
            },
            {
              id: 101,
              pubDate: 1579754424000,
              pubDateStr: "11小时前",
              title: "贵州新增新型肺炎确诊病例 2 例",
              summary:
                "据贵州卫健委，1月22日，贵州新增2例新型冠状病毒感染的肺炎确诊病例，截至1月23日12:00，贵州共确诊3例新型冠状病毒感染的肺炎病例。所有病例均有武汉居住史、旅行史和密切接触史，目前均在定点医疗机构接受隔离治疗，病情平稳，无重症病例。当地卫生健康等部门已对密切接触者进行追踪随访。",
              infoSource: "央视新闻微博",
              sourceUrl: "http://dxys.com/0QYxTk",
              provinceId: "52",
              provinceName: "贵州省",
              createTime: 1579754813000,
              modifyTime: 1579754813000
            },
            {
              id: 104,
              pubDate: 1579754265000,
              pubDateStr: "11小时前",
              title: "安徽新增 8 例新型肺炎确诊病例",
              summary:
                "1月22日16时至1月23日10时,安徽省报告新型冠状病毒感染的肺炎新增确诊病例8例。其中六安市、滁州市、阜阳市、亳州市为报告首例确诊病例，合肥市新增确诊病例4例。截至1月23日10时,安徽省累计报告新型冠状病毒感染的肺炎确诊病例9例",
              infoSource: "央视新闻微博",
              sourceUrl: "http://dxys.com/kAcvyE",
              provinceId: "34",
              provinceName: "安徽省",
              createTime: 1579758022000,
              modifyTime: 1579758022000
            },
            {
              id: 100,
              pubDate: 1579753844000,
              pubDateStr: "12小时前",
              title: "重庆新增 3 例新型肺炎确诊病例",
              summary:
                "重庆市卫健委：1月22日12—24时，重庆市报告新型冠状病毒感染的肺炎新增确诊病例3例。新增重症病例1例。其中涪陵区、永川区为报告首例确诊病例。截至1月22日24时，重庆市累计报告新型冠状病毒感染的肺炎确诊病例9例，重症病例3例。其中：确诊病例中，万州区2例、永川区2例、巫山县2例、涪陵区1例、长寿区1例、垫江县1例；重症病例中，万州区2例、巫山县1例。",
              infoSource: "央视新闻微博",
              sourceUrl: "http://dxys.com/IYMXJ9",
              provinceId: "50",
              provinceName: "重庆市",
              createTime: 1579754299000,
              modifyTime: 1579754299000
            },
            {
              id: 99,
              pubDate: 1579752195000,
              pubDateStr: "12小时前",
              title: "内蒙古发现 1 例新型肺炎疑似病例",
              summary:
                "1月23日凌晨，内蒙古自治区满洲里市发现1例新型冠状病毒感染的肺炎疑似病例。患者男，30岁，家住武汉市，从事服装生意，21日自驾游到满洲里市后，直接到满洲里市人民医院急诊科就诊。目前该患者已在定点医院接受隔离治疗，病情平稳，密切接触者已实行医学观察。患者实验室检验结果正在按规定复核中，一旦确诊，将及时向社会公布。",
              infoSource: "央视新闻微博",
              sourceUrl: "http://dxys.com/VEgUax",
              provinceId: "15",
              provinceName: "内蒙古自治区",
              createTime: 1579753015000,
              modifyTime: 1579753015000
            },
            {
              id: 98,
              pubDate: 1579750785000,
              pubDateStr: "12小时前",
              title: "湖南新增新型肺炎确诊病例 5 例",
              summary:
                "今天，湖南省新增5例新型冠状病毒感染的肺炎确诊病例,其中长沙市3例,永州市1例,郴州市1例。5名患者均有武汉暴露史。目前,5名患者病情稳定,正在当地定点医院隔离治疗,密切接触者目前无发热等异常状况。",
              infoSource: "央视新闻微博",
              sourceUrl: "http://dxys.com/vMGNUk",
              provinceId: "43",
              provinceName: "湖南省",
              createTime: 1579751419000,
              modifyTime: 1579751419000
            },
            {
              id: 97,
              pubDate: 1579750623000,
              pubDateStr: "12小时前",
              title: "辽宁新增 1 例新型肺炎确诊病例",
              summary:
                "辽宁省卫健委：今天，辽宁新增1例输入性新型冠状病毒感染的肺炎确诊病例。==目前，患者症状平稳，其密切接触者37人均在医学观察中。截至1月23日11时，辽宁省累计报告新型冠状病毒感染的肺炎确诊病例3例。目前3名患者均在定点医院隔离治疗，病情稳定。全部密切接触者均实施医学观察。",
              infoSource: "央视新闻微博",
              sourceUrl: "http://dxys.com/FCBKxS",
              provinceId: "21",
              provinceName: "辽宁省",
              createTime: 1579751110000,
              modifyTime: 1579751110000
            },
            {
              id: 96,
              pubDate: 1579749831000,
              pubDateStr: "13小时前",
              title: "福建新增 3 例新型肺炎确诊病例",
              summary:
                "今天11时，福建省报告新增输入性新型冠状病毒感染的肺炎3例。其中厦门市、泉州市、宁德市分别报告1例确诊病例，均为当地首例确诊病例。新增患者均为武汉返乡人员，目前患者病情平稳，正在接受隔离治疗，追踪到的密切接触者正在接受医学观察。",
              infoSource: "央视新闻微博",
              sourceUrl: "http://dxys.com/EWimM2",
              provinceId: "35",
              provinceName: "福建省",
              createTime: 1579750641000,
              modifyTime: 1579750641000
            },
            {
              id: 95,
              pubDate: 1579749238000,
              pubDateStr: "13小时前",
              title: "吉林确诊首例新型肺炎病例",
              summary:
                "吉林卫健委：昨天，长春市一名自武汉返乡的疑似病例经国家卫生健康委评估确认为我省首例输入性新型冠状病毒感染的肺炎确诊病例。",
              infoSource: "央视新闻微博",
              sourceUrl: "http://dxys.com/cyoeNB",
              provinceId: "22",
              provinceName: "吉林省",
              createTime: 1579750479000,
              modifyTime: 1579750479000
            },
            {
              id: 94,
              pubDate: 1579748477000,
              pubDateStr: "13小时前",
              title: "广东新增 6 例新型冠状病毒肺炎确诊病例",
              summary:
                "据广东省卫健委：1月22日0-24时，广东省报告新型冠状病毒感染的肺炎新增确诊病例6例。其中中山、肇庆各有1例为首例确诊病例。其他2个地市新增确诊病例中，广州3例、深圳1例。",
              infoSource: "央视新闻微博",
              sourceUrl: "http://dxys.com/e2Wok6",
              provinceId: "44",
              provinceName: "广东省",
              createTime: 1579749309000,
              modifyTime: 1579749309000
            },
            {
              id: 93,
              pubDate: 1579746333000,
              pubDateStr: "14小时前",
              title: "四川新增确诊3例新型肺炎病例",
              summary:
                "四川省卫健委发布：截至今天8时，四川省累计报告新型冠状病毒感染的肺炎确诊病例8例（其中成都4例、绵阳2例、广安1例、达州1例），疑似病例4 例（其中成都2例，遂宁1例，广安1例），以上12人均在定点医疗机构接受诊治，病情稳定。已对密切接触者实施医学观察，目前均无发热等异常情况",
              infoSource: "央视新闻微博",
              sourceUrl: "http://dxys.com/gQ7vXn",
              provinceId: "51",
              provinceName: "四川省",
              createTime: 1579747937000,
              modifyTime: 1579747937000
            },
            {
              id: 92,
              pubDate: 1579745922000,
              pubDateStr: "14小时前",
              title: "山东新增4例新型肺炎确诊病例",
              summary:
                "据山东省卫健委：22日0至24时，山东省报告新型冠状病毒感染的肺炎新增确诊病例4例。其中：临沂市首次报告2例确诊病例，青岛市新增2例确诊病例。",
              infoSource: "央视新闻",
              sourceUrl: "http://dxys.com/klrdJ8",
              provinceId: "37",
              provinceName: "山东省",
              createTime: 1579747671000,
              modifyTime: 1579747671000
            },
            {
              id: 89,
              pubDate: 1579740470000,
              pubDateStr: "15小时前",
              title: "上海新增7例新型冠状病毒感染的肺炎确诊病例",
              summary:
                "1月22日0时—24时，本市新增7例新型冠状病毒感染的肺炎确诊病例，均已在定点医院接受隔离治疗。患者中男性4例、女性3例，均有武汉流行病学关联。其中，1例88岁男性患者合并心肺功能不全，病情危重。密切接触者正在接受医学观察。",
              infoSource: "上海市卫健委",
              sourceUrl: "http://dxys.com/g8Vhk6",
              provinceId: "31",
              provinceName: "上海市",
              createTime: 1579741304000,
              modifyTime: 1579741304000
            },
            {
              id: 90,
              pubDate: 1579740295000,
              pubDateStr: "15小时前",
              title: "陕西新增 4 例疑似病例",
              summary:
                "自1月22日下午5时至1月23日上午8时，西安、咸阳、延安发现4例来自武汉或与武汉病例有接触并出现发热等呼吸道症状患者，其中西安2例，咸阳1例，延安1例，目前均在定点医院隔离治疗，病情稳定，密切接触者已实行医学观察。患者实验室检验结果正在按规定复核中，一旦确诊，将及时向社会公布。",
              infoSource: "央视新闻",
              sourceUrl: "http://dxys.com/gTAnvn",
              provinceId: "61",
              provinceName: "陕西省",
              createTime: 1579745179000,
              modifyTime: 1579745179000
            },
            {
              id: 88,
              pubDate: 1579738875000,
              pubDateStr: "16小时前",
              title: "截至1月22日24时，国内累计571例新型肺炎",
              summary:
                "截至1月22日24时，国家卫健委收到国内25个省（区、市）累计报告新型冠状病毒感染的肺炎确诊病例571例，其中重症95例，死亡17例（均来自湖北省）。13个省（区、市）累计报告疑似病例393例。全国共有25个省（区、市）报告疫情，新增河北、辽宁、江苏、福建4个省。",
              infoSource: "央视新闻",
              sourceUrl: "https://m.weibo.cn/2656274875/4463810716443567",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579740213000,
              modifyTime: 1579740213000
            },
            {
              id: 86,
              pubDate: 1579716965000,
              pubDateStr: "22小时前",
              title: "武汉公交地铁轮渡长途客运23日起停运",
              summary:
                "武汉市新型冠状病毒感染的肺炎疫情防控指挥部发布通告：自2020年1月23日10时起，武汉全市城市公交、地铁、轮渡、长途客运暂停运营；无特殊原因，市民不要离开武汉，机场、火车站离汉通道暂时关闭。",
              infoSource: "人民日报",
              sourceUrl:
                "https://www.weibo.com/2803301701/IqJCvwRuB?from=page_1002062803301701_profile&wvr=6&mod=weibotime&type=comment#_rnd1579731711822",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579738133000,
              modifyTime: 1579738133000
            },
            {
              id: 85,
              pubDate: 1579713325000,
              pubDateStr: "23小时前",
              title: "广西新增3例新型肺炎病例",
              summary:
                "目前，广西已确诊5例新型肺炎病例（北海3例、梧州1例、柳州1例），均有武汉居住史、工作史或武汉病例接触史。（总台央视记者张卉 尹智磊）",
              infoSource: "央视新闻",
              sourceUrl:
                "https://www.weibo.com/2656274875/IqJdjB2oy?from=page_1002062656274875_profile&wvr=6&mod=weibotime&type=comment#_rnd1579713810933",
              provinceId: "45",
              provinceName: "广西壮族自治区",
              createTime: 1579737768000,
              modifyTime: 1579737768000
            },
            {
              id: 83,
              pubDate: 1579712434000,
              pubDateStr: "23小时前",
              title: "黑龙江确诊首例新型肺炎病例",
              summary:
                "国家卫生健康委确认黑龙江省首例输入性新型冠状病毒感染的肺炎确诊病例。患者为男性，69岁，牡丹江市人。1月12日从武汉市返回牡丹江市后，因发热、咳嗽咳痰、周身乏力于牡丹江市第二医院隔离治疗。目前，患者病情较重，正处于全力救治中。该患者密切接触者正在医学观察，目前暂无异常。",
              infoSource: "央视新闻",
              sourceUrl: "https://m.weibo.cn/2656274875/4463700323132715",
              provinceId: "23",
              provinceName: "黑龙江省",
              createTime: 1579737407000,
              modifyTime: 1579737407000
            },
            {
              id: 82,
              pubDate: 1579709190000,
              pubDateStr: "1天前",
              title: "江苏确诊首例新型病毒肺炎病例",
              summary:
                "22日，国家卫健委确认苏州一例新型冠状病毒感染的肺炎确诊病例。患者为男性，37岁，现居苏州市工业园区，1月10日从武汉市返苏，至发热门诊就医，当日转至定点医疗机构隔离治疗。该病例为江苏首例新型冠状病毒感染的肺炎确诊病例。目前该患者生命体征比较平稳，体温恢复正常。",
              infoSource: "央视新闻微博",
              sourceUrl: "http://dxys.com/cLPSeF",
              provinceId: "32",
              provinceName: "江苏省",
              createTime: 1579709605000,
              modifyTime: 1579709605000
            },
            {
              id: 81,
              pubDate: 1579708236000,
              pubDateStr: "1天前",
              title: "北京新增 4 例新型肺炎病例",
              summary:
                "今天，北京新确诊 4 例新型冠状病毒感染的肺炎病例。目前，4 名患者病情平稳，在定点医院接受隔离治疗。现已对 35 名密切接触者开展医学观察，目前无发热等异常情况。截至今天 18 时，北京确诊 14 例新型肺炎病例",
              infoSource: "央视新闻微博",
              sourceUrl: "http://dxys.com/ouXa91",
              provinceId: "11",
              provinceName: "北京市",
              createTime: 1579708788000,
              modifyTime: 1579708788000
            },
            {
              id: 80,
              pubDate: 1579704654000,
              pubDateStr: "1天前",
              title: "河北确诊首例新型肺炎病例",
              summary:
                "22日，国家卫生健康委确认河北省首例新型冠状病毒感染的肺炎确诊病例。患者李某，男，72岁，武汉市人。当前，患者继续在定点医院隔离治疗，病情平稳。河北省已对6名密切接触者开展了隔离医学观察，目前无发热等异常情况。",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqIgXzszS?filter=hot&root_comment_id=0&type=comment#_rnd1579704801559",
              provinceId: "13",
              provinceName: "河北省",
              createTime: 1579704888000,
              modifyTime: 1579704888000
            },
            {
              id: 79,
              pubDate: 1579704221000,
              pubDateStr: "1天前",
              title: "武汉确诊新型肺炎363例死亡9例",
              summary:
                "截至1月21日24时，武汉市累计报告新型冠状病毒感染肺炎病例363例，已治愈出院28例，死亡9例。其中，武汉新增确诊新型肺炎105例，新增死亡病例3例。",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqIdQBHpP?filter=hot&root_comment_id=0&type=comment",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579704466000,
              modifyTime: 1579704466000
            },
            {
              id: 78,
              pubDate: 1579702982000,
              pubDateStr: "1天前",
              title: "新型肺炎已致湖北17人死亡",
              summary:
                "湖北省政府召开新闻发布会，截至今天晚上8点，湖北省累计报告新型冠状病毒感染病例444例，17人死亡。 ​​​",
              infoSource: "人民日报",
              sourceUrl: "https://m.weibo.cn/2803301701/4463659813970854",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579703273000,
              modifyTime: 1579703273000
            },
            {
              id: 76,
              pubDate: 1579699856000,
              pubDateStr: "1天前",
              title: "武汉对进出城车辆人员实施疫情排查",
              summary:
                "为有效应对新型冠状病毒感染的肺炎疫情，武汉市决定即日起（22日）全市启动进出城道口重大疫情排查防控工作，依法依规对过往车辆及人员实施疫情排查防控。市指挥部要求各区依托全市公安检查站设置疫情检测点，严格筛查检测，坚决防止疫情输出扩散风险。不漏一车不漏一人！",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqHKm9Vds?filter=hot&root_comment_id=0&type=comment#_rnd1579700622631",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579700831000,
              modifyTime: 1579700831000
            },
            {
              id: 77,
              pubDate: 1579699766000,
              pubDateStr: "1天前",
              title: "山东省威海市确认1例输入性新型肺炎确诊病例",
              summary:
                "1月22日，山东省威海市确认1例输入性新型冠状病毒感染的肺炎确诊病例。 患者为38岁男性，在浙江省舟山市工作，曾密切接触过新型冠状病毒感染的肺炎确诊病人，1月18日赴威海乳山市探亲，1月20日因发烧在威海市就诊后被收入院隔离治疗。",
              infoSource: "人民日报",
              sourceUrl: "https://wap.peopleapp.com/article/5068189/4962549",
              provinceId: "37",
              provinceName: "山东省",
              createTime: 1579701996000,
              modifyTime: 1579701996000
            },
            {
              id: 75,
              pubDate: 1579695880000,
              pubDateStr: "1天前",
              title: "香港发现1例高度怀疑为新型肺炎个案",
              summary:
                "22日晚，香港特区政府食物及卫生局局长陈肇始表示，香港发现一例高度怀疑新型冠状病毒肺炎个案。初步化验结果为阳性。该患者39岁，21日晚乘高铁抵港，曾到过武汉，现在在当地医院传染病中心接受隔离治疗。",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqHjqh1E7?filter=hot&root_comment_id=0&type=comment#_rnd1579696477039",
              provinceId: "66",
              provinceName: "香港",
              createTime: 1579696835000,
              modifyTime: 1579696835000
            },
            {
              id: 87,
              pubDate: 1579695816000,
              pubDateStr: "1天前",
              title: "工信部紧急协调口罩生产确保市场供应",
              summary:
                "针对近日新型冠状病毒感染的肺炎疫情加重，导致相关类型口罩需求量暴增的情况，工信部正按照重大传染病联防联控工作机制要求，紧急协调各省、市、自治区工信部门组织本地口罩生产企业克服春节期间用工困难，尽快抓紧生产，有效保障市场供应。",
              infoSource: "央视新闻",
              sourceUrl:
                "https://www.weibo.com/2656274875/IqHv2736b?refer_flag=1001030103_",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579738223000,
              modifyTime: 1579738223000
            },
            {
              id: 84,
              pubDate: 1579695554000,
              pubDateStr: "1天前",
              title: "三部门发紧急通知：加强野生动物市场监管 积极做好疫情防控",
              summary:
                "1月21日，国家市场监管总局、农业农村部、国家林业和草原局下发《关于加强野生动物市场监管 积极做好疫情防控工作的紧急通知》，要求各地林草、农业农村和市场监管部门依照《中华人民共和国野生动物保护法》规定和职责分工，突出饲养、繁育、运输、出售、购买等环节，加强检验检疫力度。",
              infoSource: "央视新闻客户端",
              sourceUrl:
                "http://m.news.cctv.com/2020/01/22/ARTI5g3qj3fWm34yoBvb5Sgy200122.shtml",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579737518000,
              modifyTime: 1579737518000
            },
            {
              id: 74,
              pubDate: 1579692972000,
              pubDateStr: "1天前",
              title: "全国已确诊473例新型肺炎病例",
              summary:
                "新型肺炎疫情最新汇总：截至1月22日19时20分，全国新型冠状病毒感染肺炎确诊473例。 ​​​",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqH09DyCi?filter=hot&root_comment_id=0&type=comment#_rnd1579693620799",
              provinceId: "11",
              provinceName: "北京市",
              createTime: 1579695587000,
              modifyTime: 1579695587000
            },
            {
              id: 73,
              pubDate: 1579692196000,
              pubDateStr: "1天前",
              title: "河南新增4例新型肺炎确诊病例，均有武汉居住史",
              summary:
                "截至2020年1月22日18时，河南累计报告新型冠状病毒感染的肺炎病例5例（郑州市2例、洛阳市1例、三门峡市1例、巩义市1例）。所有病例均有武汉居住史，目前均在定点医疗机构接受隔离治疗。无死亡病例。",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqGV4lCay?from=page_1002062803301701_profile&wvr=6&mod=weibotime&type=comment#_rnd1579692531310",
              provinceId: "41",
              provinceName: "河南省",
              createTime: 1579692592000,
              modifyTime: 1579692592000
            },
            {
              id: 72,
              pubDate: 1579691966000,
              pubDateStr: "1天前",
              title: "广西确诊2例新型肺炎病例",
              summary:
                "首例确诊病例黄某，女，66岁，武汉市民，2020年1月12日，黄某跟随家人从武汉市出发自驾旅行，1月16日下午到达北海市，自觉身体不适，1月17日就诊并收住院治疗，现患者体温正常，生命体征平稳，38名密切接触者正在医学观察中。此外柳州市新增疑似病例1例。",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqGTwh0C1?from=page_1002062803301701_profile&wvr=6&mod=weibotime&type=comment#_rnd1579692168196",
              provinceId: "45",
              provinceName: "广西壮族自治区",
              createTime: 1579692348000,
              modifyTime: 1579692348000
            },
            {
              id: 71,
              pubDate: 1579691776000,
              pubDateStr: "1天前",
              title: "宁夏确诊首例新型肺炎病例：在武汉工作",
              summary:
                "今天，国家卫健委确认宁夏首例输入性新型冠状病毒感染的肺炎确诊病例。患者为男性，29岁，宁夏人，在武汉工作。1月19日乘飞机抵达银川，当晚在自治区人民医院就诊后隔离治疗。专家组确认该病例为新型冠状病毒感染的肺炎确诊病例。现患者病情稳定。 ​​​",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2656274875/IqGRMsgUh?from=page_1002062656274875_profile&wvr=6&mod=weibotime&type=comment#_rnd1579691823662",
              provinceId: "64",
              provinceName: "宁夏回族自治区",
              createTime: 1579691875000,
              modifyTime: 1579691875000
            },
            {
              id: 69,
              pubDate: 1579689629000,
              pubDateStr: "1天前",
              title: "四川新增3例新型肺炎病例",
              summary:
                "截止22日16时，四川累计报告新型冠状病毒感染的肺炎确诊病例5例（其中成都2例、绵阳2例、广安1例），疑似病例2例（均在成都），以上7人均在定点医疗机构接受诊治，病情稳定。已对密切接触者实施医学观察，目前均无发热等异常情况。",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2656274875/IqGDxbyp4?from=page_1002062656274875_profile&wvr=6&mod=weibotime&type=comment#_rnd1579690172738",
              provinceId: "51",
              provinceName: "四川省",
              createTime: 1579690379000,
              modifyTime: 1579690379000
            },
            {
              id: 68,
              pubDate: 1579689286000,
              pubDateStr: "1天前",
              title: "山西确诊首例新型肺炎病例",
              summary:
                "今天，国家卫健委确认山西省首例新型冠状病毒感染的肺炎确诊病例。患者，男，太原市人，1月12日至15日在武汉旅游。19日出现发热伴头痛症状。20日到山西白求恩医院发热门诊就诊。21日转至山西省定点医院（太原市第四人民医院）隔离治疗。目前患者病情稳定。已对6名密切接触者进行了追踪和医学观察，目前无异常。",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2656274875/IqGCB0OTO?from=page_1002062656274875_profile&wvr=6&mod=weibotime&type=comment#_rnd1579689880506",
              provinceId: "14",
              provinceName: "山西省",
              createTime: 1579690002000,
              modifyTime: 1579690002000
            },
            {
              id: 70,
              pubDate: 1579689020000,
              pubDateStr: "1天前",
              title: "重庆共确诊6例新型肺炎病例",
              summary:
                "1月21日18时-1月22日12时，重庆市新增1例输入性新型冠状病毒感染的肺炎确诊病例，累计报告确诊病例6例（万州2例、巫山2例、长寿1例、垫江1例），均有在武汉居住史或工作史，其中重症2例。所有患者均在定点医院接受治疗，目前病情平稳。所有密切接触者81人正在接受医学观察。",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2656274875/IqGziv9jc?from=page_1002062656274875_profile&wvr=6&mod=weibotime&type=comment#_rnd1579691145918",
              provinceId: "50",
              provinceName: "重庆市",
              createTime: 1579691215000,
              modifyTime: 1579691215000
            },
            {
              id: 67,
              pubDate: 1579688743000,
              pubDateStr: "1天前",
              title: "湖南新增3例新型肺炎病例",
              summary:
                "湖南省新增3例新型冠状病毒感染的肺炎确诊病例，患者均为怀化市鹤城区人。患者杨某某，女，35岁；李某某，女，40岁；彭某某，男，30岁，3人为同一公司同事。杨某某与李某某12月下旬到过武汉，彭某某与其中1人是密切接触者。目前，3名患者病情稳定，正在怀化市定点医院隔离治疗，当地卫生健康等部门已对密切接触者进行追踪随访，密切接触者目前无发热等异常状况。",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2656274875/IqGxKc0Bq?from=page_1002062656274875_profile&wvr=6&mod=weibotime&type=comment#_rnd1579688920401",
              provinceId: "43",
              provinceName: "湖南省",
              createTime: 1579689020000,
              modifyTime: 1579689020000
            },
            {
              id: 66,
              pubDate: 1579688150000,
              pubDateStr: "1天前",
              title: "贵州确诊首例新型肺炎病例",
              summary:
                "今天，国家卫健委确认贵州首例输入性新型冠状病毒感染的肺炎确诊病例。患者为51岁，男性，现居贵阳，发病前一周有武汉居住史，1月14日因发热就诊。经省疾控中心初步检测，按规定程序报中国疾控中心病毒核酸检测，检测结果为阳性。当前，患者在定点医院隔离治疗，病情平稳。",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2803301701/IqGtrCQPF?from=page_1002062803301701_profile&wvr=6&mod=weibotime&type=comment#_rnd1579688463221",
              provinceId: "52",
              provinceName: "贵州省",
              createTime: 1579688741000,
              modifyTime: 1579688741000
            },
            {
              id: 65,
              pubDate: 1579687520000,
              pubDateStr: "1天前",
              title: "福建确诊首例新型肺炎病例",
              summary:
                "1月22日，国家卫生健康委确认福建省首例输入性新型冠状病毒感染的肺炎确诊病例。患者为男性，70岁，福州市连江县人，在武汉市工作，1月17日返回连江县，1月20日至连江县医院就诊并收治入院隔离治疗。目前，患者病情稳定，其在闽密切接触者正在接受医学观察。",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqGpc5njk?from=page_1002062803301701_profile&wvr=6&mod=weibotime&type=comment#_rnd1579687678831",
              provinceId: "35",
              provinceName: "福建省",
              createTime: 1579688246000,
              modifyTime: 1579688246000
            },
            {
              id: 63,
              pubDate: 1579684171000,
              pubDateStr: "1天前",
              title: "安徽确诊首例新型肺炎病例",
              summary:
                "22日16时，经国家卫生健康委确认，安徽省收到合肥市报告的首例新型冠状病毒感染的肺炎为确诊病例。另截至1月22日16时，省卫生健康委收到省内2市累计报告新型冠状病毒感染的肺炎疑似病例4例（合肥市3例，六安市1例）",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqG2VvjtS?ref=home&rid=0_0_8_2704774672808346954_0_0_0&type=comment#_rnd1579684374015",
              provinceId: "34",
              provinceName: "安徽省",
              createTime: 1579685159000,
              modifyTime: 1579685159000
            },
            {
              id: 64,
              pubDate: 1579683423000,
              pubDateStr: "1天前",
              title:
                "湖北多地发现新型肺炎疑似和确诊病例，湖北拟请求紧急支援口罩等医用物资",
              summary:
                "湖北荆州已发现新型冠状病毒感染的肺炎确诊病例6例，襄阳、宜昌、十堰、荆门、咸宁、鄂州、恩施、仙桃、天门、潜江等多地发现疑似病例。 各地严防死守、严阵以待，但均不同程度出现医用口罩、防护服、测温仪等防疫物资短缺现象。湖北省拟向国家请求紧急支援，调拨医用口罩、防护服、红外测温仪等防疫物资。",
              infoSource: "人民日报",
              sourceUrl:
                "https://weibo.com/2803301701/IqFXe9Jj5?from=page_1002062803301701_profile&wvr=6&mod=weibotime&type=comment#_rnd1579685469593",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579685650000,
              modifyTime: 1579685650000
            },
            {
              id: 62,
              pubDate: 1579681206000,
              pubDateStr: "1天前",
              title: "海南确诊4例新型肺炎病例",
              summary:
                "截至今天，海南省共确诊4例新型冠状病毒感染的肺炎病例，均为输入性病例。4例患者病情平稳，体温已恢复正常，正在定点医院隔离治疗，当地卫生健康部门已对其密切接触者进行追踪随访，密切接触者目前无发热等异常状况。",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2656274875/IqFIDEm8X?ref=home&rid=0_0_8_3071520091955001893_0_0_0&type=comment#_rnd1579681405323",
              provinceId: "46",
              provinceName: "海南省",
              createTime: 1579681790000,
              modifyTime: 1579681790000
            },
            {
              id: 60,
              pubDate: 1579680884000,
              pubDateStr: "1天前",
              title: "2020年1月22日新型冠状病毒感染的肺炎疫情情况",
              summary:
                "截至1月21日24时，我委收到国内13省（区、市）累计报告新型冠状病毒感染的肺炎确诊病例440例（北京市10例、天津市2例、上海市9例、浙江省5例、江西2例、山东省1例、河南省1例、湖北省375例、湖南省1例、广东省26例、重庆市5例、四川省2例和云南省1例），其中重症102例，死亡9例（均来自湖北省）；除湖北省外，12省（区、市）累计报告疑似病例37例。",
              infoSource: "卫生应急办公室",
              sourceUrl:
                "http://www.nhc.gov.cn/yjb/s3578/202001/a3c8b5144067417889d8760254b1a7ca.shtml",
              provinceId: "11",
              provinceName: "北京市",
              createTime: 1579681139000,
              modifyTime: 1579681139000
            },
            {
              id: 61,
              pubDate: 1579680853000,
              pubDateStr: "1天前",
              title: "辽宁确认2例新型肺炎病例",
              summary:
                "截至今天14时，辽宁省共确认2例新型冠状病毒感染的肺炎确诊病例。患者男性，33岁，在武汉工作，目前，患者属重症病例，生命体征平稳，其密切接触者56人均在医学观察中。患者男性，40岁，在湖北省仙桃市工作，目前，患者症状较轻，其密切接触者31人均在医学观察中。",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2656274875/IqFFYc2Gv?from=page_1002062656274875_profile&wvr=6&mod=weibotime&type=comment#_rnd1579681472425",
              provinceId: "21",
              provinceName: "辽宁省",
              createTime: 1579681691000,
              modifyTime: 1579681691000
            },
            {
              id: 91,
              pubDate: 1579677924000,
              pubDateStr: "1天前",
              title: "武汉同济、武汉协和同时发布新型冠状病毒肺炎快速诊疗指南",
              summary:
                "1 月 22 日，同济医院专家组编写《新型冠状病毒肺炎诊疗快速指南》，以及来自华中科技大学同济医学院附属协和医院的《武汉协和医院处置 2019 新型冠状病毒感染策略及说明》对外发布（点击次条可跳转查看具体内容）。",
              infoSource: "丁香园",
              sourceUrl: "https://mp.weixin.qq.com/s/lo_Yd1ikwVWeCB59UJtTTQ",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579746839000,
              modifyTime: 1579746839000
            },
            {
              id: 59,
              pubDate: 1579674525000,
              pubDateStr: "1天前",
              title: "天津新增2例新型肺炎确诊病例",
              summary:
                "截至22日12时，天津市新增2例新型冠状病毒感染的肺炎确诊病例，均已在定点医院接受隔离治疗，生命体征平稳。患者中女性1例，67岁；男性1例，40岁，均有武汉工作史。密切接触者正在接受医学观察。截至目前，天津累计发现新型肺炎病例4例。",
              infoSource: "央视新闻",
              sourceUrl: "https://m.weibo.cn/status/4463540671056698?",
              provinceId: "12",
              provinceName: "天津市",
              createTime: 1579675324000,
              modifyTime: 1579675324000
            },
            {
              id: 57,
              pubDate: 1579671046000,
              pubDateStr: "1天前",
              title: "泰国共发现4例新型肺炎病例",
              summary:
                "今天，泰国副总理兼卫生部长阿努霆表示，截至目前，在泰国共发现4例感染新型冠状病毒肺炎病例，其中3人是中国籍，1人是泰国籍，均与高风险地区人员有接触史。两位中国患者已经治愈，分别在18日、21日回国。另两位患者正在泰国接受治疗。",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2656274875/IqEwEpvsJ?ref=home&rid=3_536870912_8_4726744129282722366_0_0_0&type=comment#_rnd1579670618259",
              provinceId: "1",
              createTime: 1579672608000,
              modifyTime: 1579672608000
            },
            {
              id: 55,
              pubDate: 1579667436000,
              pubDateStr: "1天前",
              title: "广东新增9例新型肺炎确诊病例",
              summary:
                "截至21日24:00，广东省新增报告9例新型冠状病毒感染的肺炎确诊病例。新增病例分布如下：广州2例、深圳4例、佛山1例、韶关2例；男性4例、女性5例；重症2例，均收治在当地定点医疗机构隔离治疗。",
              infoSource: "央视新闻",
              sourceUrl: "https://m.weibo.cn/status/4463511738486595?",
              provinceId: "44",
              provinceName: "广东省",
              createTime: 1579670077000,
              modifyTime: 1579670077000
            },
            {
              id: 56,
              pubDate: 1579667431000,
              pubDateStr: "1天前",
              title: "浙江累计报告新型肺炎病例10例",
              summary:
                "截至今日12时，浙江省累计报告新型冠状病毒感染的肺炎病例10例，其中杭州1例、宁波3例、温州4例、舟山1例、台州1例。",
              infoSource: "央视新闻",
              sourceUrl: "https://m.weibo.cn/status/4463510434284981?",
              provinceId: "33",
              provinceName: "浙江省",
              createTime: 1579670531000,
              modifyTime: 1579670531000
            },
            {
              id: 58,
              pubDate: 1579666740000,
              pubDateStr: "1天前",
              title: "同济专家组制定《新型冠状病毒肺炎诊疗快速指南》",
              summary:
                "同济医院专家组迅速反应，根据包括同济医院在内的武汉各大医疗机构诊治的第一批患者的第一手资料，第一时间制定了《新型冠状病毒肺炎诊疗快速指南》。",
              infoSource: "武汉晚报",
              sourceUrl: "https://mp.weixin.qq.com/s/6We-i_DzgnjUMcYaHLM-wQ",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579672943000,
              modifyTime: 1579672943000
            },
            {
              id: 54,
              pubDate: 1579663513000,
              pubDateStr: "1天前",
              title: "儿童年轻人对病毒不易感，但病毒在适应突变",
              summary:
                "中国科学院院士、中国疾病预防控制中心主任高福表示，病毒和人类的关系就像“猫鼠游戏”。新型冠状病毒可能是从野生动物及被污染的环境中来，一开始是动物传人，但病毒在适应突变。目前证据确实显示儿童、年轻人对病毒不易感。 ​",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2656274875/IqDTFgnJI?from=page_1002062656274875_profile&wvr=6&mod=weibotime&type=comment#_rnd1579665720969",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579665964000,
              modifyTime: 1579665964000
            },
            {
              id: 53,
              pubDate: 1579663357000,
              pubDateStr: "1天前",
              title: "澳门确诊首例新型肺炎感染案例",
              summary:
                "澳门新型冠状病毒感染应变协调中心今天 11 时召开新闻发布会。会上发布消息称，澳门出现首例确诊新型冠状病毒感染的案例，患者为一名来自武汉的 52 岁女子，其咽痛、咳嗽约一周，昨日到医院求诊，即时隔离。",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2656274875/IqDIS0pET?from=page_1002062656274875_profile&wvr=6&mod=weibotime&type=comment#_rnd1579663328836",
              provinceId: "67",
              provinceName: "澳门",
              createTime: 1579663406000,
              modifyTime: 1579663406000
            },
            {
              id: 49,
              pubDate: 1579659245000,
              pubDateStr: "1天前",
              title: "国内新型肺炎确诊 440 例",
              summary:
                "国家卫健委介绍新型冠状病毒肺炎感染情况：截至 21 日 24 时，国内新型肺炎确诊 440 例，死亡 9 例。",
              infoSource: "央视新闻",
              sourceUrl: "https://m.weibo.cn/2656274875/4463476765896816",
              provinceId: "11",
              provinceName: "北京市",
              createTime: 1579661385000,
              modifyTime: 1579661385000
            },
            {
              id: 50,
              pubDate: 1579658541000,
              pubDateStr: "1天前",
              title: "上海新增3例新型冠状病毒感染的肺炎确诊病例",
              summary:
                "1月21日19时—24时，上海新增3例新型冠状病毒感染的肺炎确诊病例，均已在定点医院接受隔离治疗。截至1月21日24时，上海累计发现确诊病例9例，患者目前病情平稳，无重症病例。",
              infoSource: "上海发布",
              sourceUrl: "https://mp.weixin.qq.com/s/0DW5LLu6AVZK_qMW6ypgHQ",
              provinceId: "31",
              provinceName: "上海市",
              createTime: 1579662056000,
              modifyTime: 1579662056000
            },
            {
              id: 48,
              pubDate: 1579655591000,
              pubDateStr: "1天前",
              title: "合肥新增 2 例新型肺炎疑似病例",
              summary:
                "截止昨天18:00，合肥市新增2例新型冠状病毒感染的肺炎疑似病例。患者目前已在定点医院接受隔离治疗，病情平稳。截至目前，合肥市累计发现新型冠状病毒感染的肺炎疑似病例3例。",
              infoSource: "央视新闻",
              sourceUrl: "https://m.weibo.cn/2656274875/4463461490814361",
              provinceId: "34",
              provinceName: "安徽省",
              createTime: 1579657153000,
              modifyTime: 1579657153000
            },
            {
              id: 51,
              pubDate: 1579655201000,
              pubDateStr: "1天前",
              title: "国家卫健委专家组成员疑似感染#新型肺炎，在隔离治疗中",
              summary:
                "记者从北京大学第一医院获悉，呼吸和危重症医学科主任王广发疑似感染新型冠状病毒肺炎，目前正在隔离治疗。王广发是新型肺炎专家组成员，曾随国家卫健委专家组前往武汉。2003年SARS疫情期间，王广发始终奋战第一线。",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2656274875/IqCSrAXel?from=page_1002062656274875_profile&wvr=6&mod=weibotime",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579662275000,
              modifyTime: 1579662275000
            },
            {
              id: 47,
              pubDate: 1579650474000,
              pubDateStr: "1天前",
              title: "湖北启动突发公共卫生事件二级应急响应",
              summary:
                "22 日凌晨，湖北发布加强新型肺炎防控通告：根据《中华人民共和国传染病防治法》等有关法律法规的规定，省人民政府决定启动突发公共卫生事件 II 级应急响应。通告包括严格实行属地管理制度、严格实施隔离措施等7部分。",
              infoSource: "人民日报",
              sourceUrl:
                "https://www.weibo.com/2803301701/IqClL8Mv4?from=page_1002062803301701_profile&wvr=6&mod=weibotime&type=comment#_rnd1579651850071",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579653276000,
              modifyTime: 1579653276000
            },
            {
              id: 46,
              pubDate: 1579635059000,
              pubDateStr: "1天前",
              title: "美国确诊首例新型冠状病毒肺炎",
              summary:
                "美国疾病预防控制中心证实，华盛顿州的一名男子被确诊感染新型冠状病毒。这是美国确诊的首例新型肺炎病例。这名男子是华盛顿州斯诺霍米什县居民，他从中国武汉周边地区旅行回来后出现了症状。",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2656274875/IqAGbbtmh?from=page_1002062656274875_profile&wvr=6&mod=weibotime",
              provinceId: "1",
              createTime: 1579653168000,
              modifyTime: 1579653168000
            },
            {
              id: 45,
              pubDate: 1579630633000,
              pubDateStr: "1天前",
              title: "江西确诊 2 例新型肺炎病例",
              summary:
                "昨天，国家卫生健康委确认江西首例输入性新型冠状病毒感染的肺炎确诊病例。患者罗某某，男，56岁，抚州市东乡区人。2019年12月20日赴武汉市进货，2020年1月9日返回东乡区。1月10日，因发热、咳嗽等症状入院隔离治疗。昨天，经专家确认为新型冠状病毒感染的肺炎确诊病例。",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2656274875/IqAcyp3Jr?from=page_1002062656274875_profile&wvr=6&mod=weibotime",
              provinceId: "36",
              provinceName: "江西省",
              createTime: 1579653099000,
              modifyTime: 1579653099000
            },
            {
              id: 52,
              pubDate: 1579628308000,
              pubDateStr: "1天前",
              title: "四川省新增3例输入性新型冠状病毒感染的肺炎疑似病例",
              summary:
                "2020年1月22日，四川省卫生健康委通报我市新增3例输入性新型冠状病毒感染的肺炎疑似病例，皆由武汉来蓉，目前均在定点医疗机构隔离治疗，病情稳定。",
              infoSource: "成都卫健委官方微博",
              sourceUrl: "https://m.weibo.cn/status/4463347036420665?",
              provinceId: "51",
              provinceName: "四川省",
              createTime: 1579662429000,
              modifyTime: 1579662429000
            },
            {
              id: 44,
              pubDate: 1579627621000,
              pubDateStr: "1天前",
              title: "四川确诊第 2 例新型肺炎病例",
              summary:
                "据四川卫健委，四川已确诊第二例输入性新型冠状病毒感染的肺炎病例。患者为57岁男性，常住武汉，1月15日乘火车返回四川广安，因发热、咳嗽于16日至广安市某医院就诊，医院随即收治隔离。四川省新发现5例疑似病例，均证实为武汉返回人员，其中成都3例，绵阳2例。",
              infoSource: "央视新闻",
              sourceUrl:
                "https://weibo.com/2656274875/IqzRU3150?from=page_1002062656274875_profile&wvr=6&mod=weibotime",
              provinceId: "51",
              provinceName: "四川省",
              createTime: 1579652937000,
              modifyTime: 1579652937000
            },
            {
              id: 41,
              pubDate: 1579624208000,
              pubDateStr: "2天前",
              title: "湖南确诊 1 例新型肺炎病例",
              summary:
                "21日，国家卫健委确认湖南长沙市首例输入性新型冠状病毒感染的肺炎确诊病例。患者罗某某，女，57岁，武汉市青山区人，来长沙市探亲，因出现发热、咳嗽等症状， 1月16日至医院就诊后被收至定点医院隔离治疗。目前，该患者病情平稳，体温已恢复正常。卫生健康部门已对其密切接触者进行追踪随访，所有密切接触者均无发热等异常状况。",
              infoSource: "湖南省卫健委",
              sourceUrl: "http://dxys.com/10qE5r",
              provinceId: "43",
              provinceName: "湖南省",
              createTime: 1579623634000,
              modifyTime: 1579623634000
            },
            {
              id: 43,
              pubDate: 1579623707000,
              pubDateStr: "2天前",
              title: "云南确诊 1 例新型肺炎病例",
              summary:
                "今天，国家卫健委确认昆明市首例输入性新型冠状病毒感染的肺炎确诊病例。患者为51岁男性，湖北省武汉市户籍。15日自武汉来昆。因发热、乏力等症状，16日到云南省第三人民医院就诊，17日转诊到云南省传染病医院隔离治疗。今天，经国家卫生健康委疫情应对处置领导小组的专家评估确认，该病例为新型冠状病毒感染的肺炎确诊病例。",
              infoSource: "央视新闻微博",
              sourceUrl: "http://dxys.com/4oWkYo",
              provinceId: "53",
              provinceName: "云南省",
              createTime: 1579623744000,
              modifyTime: 1579623744000
            },
            {
              id: 42,
              pubDate: 1579623652000,
              pubDateStr: "2天前",
              title: "山东确诊1例新型肺炎病例",
              summary:
                "今天，山东确诊1例新型冠状病毒感染的肺炎患者。患者为37岁男性，武汉人，在山东日照市工作。因发热等症状，于17日在日照市就诊，当晚自行至青岛市就诊。经预检分诊了解到其发病前两周内有武汉居住史，立即被收治入院隔离治疗。目前，患者生命体征平稳。青岛市8名、日照市45名密切接触者正接受医学观察。（总台央视记者窦效磊）",
              infoSource: "央视新闻微博",
              sourceUrl: "http://dxys.com/wzDWjR",
              provinceId: "37",
              provinceName: "山东省",
              createTime: 1579623689000,
              modifyTime: 1579623689000
            },
            {
              id: 40,
              pubDate: 1579621284000,
              pubDateStr: "2天前",
              title: "黑龙江牡丹江发现 1 例疑似新型肺炎患者",
              summary:
                "记者从黑龙江省牡丹江市卫生健康委获悉，今天，黑龙江牡丹江市第二医院呼吸科收治一位去武汉探亲返回的69岁男性危重肺炎患者，初步判定新型冠状病毒感染可疑病人，按诊断程序，需进一步确诊。（总台央视记者王跃军 张艺馨） ​​​​",
              infoSource: "央视新闻微博",
              sourceUrl: "http://dxys.com/NE3zI6",
              provinceId: "23",
              provinceName: "黑龙江省",
              createTime: 1579621314000,
              modifyTime: 1579621314000
            },
            {
              id: 39,
              pubDate: 1579619145000,
              pubDateStr: "2天前",
              title: "北京新增 5 例新型冠状病毒感染的肺炎病例",
              summary:
                "根据临床症状和流行病学调查，经疾病预防控制中心检测、专家组评估，以上5名患者今日确诊为新型冠状病毒感染的肺炎病例。5名患者病情平稳，在定点医院接受隔离治疗。现已对21名密切接触者开展医学观察，目前无发热等异常情况。 截至1月21日18时，我市共确诊10例新型冠状病毒感染的肺炎病例，其中西城区1例、海淀区2例、丰台区1例、通州区1例、大兴区2例、昌平区2例，武汉来京人员1例。",
              infoSource: "北京市卫生健康委员会",
              sourceUrl: "http://dxys.com/iMaKm3",
              provinceId: "11",
              provinceName: "北京市",
              createTime: 1579619734000,
              modifyTime: 1579619734000
            },
            {
              id: 38,
              pubDate: 1579617209000,
              pubDateStr: "2天前",
              title: "广东省新增 3 例确诊新型肺炎病例",
              summary:
                "截至今天18:00，广东省新增3例新型冠状病毒感染的肺炎确诊病例。新增病例分布如下：深圳、珠海、湛江各1例，均收治在当地定点医疗机构隔离治疗。其中，男性1例、女性2例。3例均有湖北居住史或旅行史，为散发病例，其中，重症1例。广东已对密切接触者进行追踪随访，目前暂无异常。截至目前，#广东确诊新型肺炎病例17例#，其中重症5例，危重2例，无死亡病例，另有4例疑似病例正在排查中。",
              infoSource: "央视新闻微博",
              sourceUrl: "http://dxys.com/gb23sc",
              provinceId: "44",
              provinceName: "广东省",
              createTime: 1579617613000,
              modifyTime: 1579617613000
            },
            {
              id: 37,
              pubDate: 1579617208000,
              pubDateStr: "2天前",
              title: "四川确诊首例新型肺炎病例",
              summary:
                "今天，国家卫健委确认四川省首例输入性新型冠状病毒感染的肺炎确诊病例。患者为34岁男性，武汉某公司职员。从武汉到达成都后，11日因发热前往成都市某医院就诊，医院随即收治隔离。目前，患者在定点医院隔离治疗，病情平稳。（总台央视记者庞丁丁） ​​​​",
              infoSource: "央视新闻微博",
              sourceUrl: "http://dxys.com/4W6FSz",
              provinceId: "51",
              provinceName: "四川省",
              createTime: 1579617360000,
              modifyTime: 1579617360000
            },
            {
              id: 36,
              pubDate: 1579612222000,
              pubDateStr: "2天前",
              title: "重庆市确诊5例输入性新型冠状病毒感染的肺炎病例",
              summary:
                "1月21日晚，国家卫生健康委确认重庆市首例输入性新型冠状病毒感染的肺炎确诊病例。截至1月21日18时，我市累计报告新型冠状病毒感染的肺炎确诊病例5例，其中：巫山县2例、万州区2例、长寿区1例。所有病例均有武汉工作史或居住史。目前5名患者在定点医疗机构接受诊治，病情稳定。对72名密切接触者实施医学观察，目前无发热等异常情况。",
              infoSource: "重庆市卫健委",
              sourceUrl: "http://dxys.com/mxDA6W",
              provinceId: "50",
              provinceName: "重庆市",
              createTime: 1579612876000,
              modifyTime: 1579612876000
            },
            {
              id: 32,
              pubDate: 1579606920000,
              pubDateStr: "2天前",
              title:
                "国家卫生健康委确认河南省郑州市首例输入性新型冠状病毒感染的肺炎确诊病例。",
              summary:
                "国家卫生健康委确认我省首例输入性新型冠状病毒感染的肺炎确诊病例",
              infoSource: "河南省卫生健康委微博",
              sourceUrl: "http://dxys.com/B17WAO",
              provinceId: "41",
              provinceName: "河南省",
              createTime: 1579606671000,
              modifyTime: 1579606671000
            },
            {
              id: 33,
              pubDate: 1579606100000,
              pubDateStr: "2天前",
              title: "香港发现117名疑似感染新型肺炎患者",
              summary:
                "截至今天12时，香港共发现疑似感染新型冠状病毒肺炎患者117人。今天香港公立医院向卫生部门通报，过去24小时共接收11名（5男6女、年龄由8岁至82岁）疑似感染新型冠状病毒肺炎患者。医院已经实施限制探病措施。（总台央视记者骆群）",
              infoSource: "央视新闻微博",
              sourceUrl: "https://m.weibo.cn/2656274875/4463253767857045",
              provinceId: "66",
              provinceName: "香港",
              createTime: 1579606956000,
              modifyTime: 1579606956000
            },
            {
              id: 34,
              pubDate: 1579605653000,
              pubDateStr: "2天前",
              title: "上海新增4例新型肺炎确诊病例",
              summary:
                "截至今天19：00，上海市新增4例新型冠状病毒感染的肺炎确诊病例。患者中男性3例、女性1例，上海户籍2例、武汉户籍2例。其中，3例有武汉居住史或旅行史，1例从密切接触者中发现，均已在定点医院接受隔离治疗。目前，上海累计发现确诊病例6例，患者病情平稳，无重症病例。另有3例疑似病例正在排查中。（总台央视记者陈雯）",
              infoSource: "央视新闻微博",
              sourceUrl: "https://m.weibo.cn/2656274875/4463252362843374",
              provinceId: "31",
              provinceName: "上海市",
              createTime: 1579607042000,
              modifyTime: 1579607042000
            },
            {
              id: 31,
              pubDate: 1579602626000,
              pubDateStr: "2天前",
              title: "台湾省确诊1例新型冠状病毒肺炎患者，患者在武汉工作",
              summary:
                "据央视，台湾省“流行疫情指挥中心”证实，一名50岁左右的台湾女性确诊感染2019新型冠状病毒。这是此次新型冠状病毒肺炎疫情扩散以来，第一起移入台湾的病例。据了解，这名患者是在武汉工作，在返台时主动告知机场检疫人员，目前正在隔离治疗中。",
              infoSource: "人民日报微博",
              sourceUrl: "https://m.weibo.cn/2803301701/4463238236280907",
              provinceId: "68",
              provinceName: "台湾",
              createTime: 1579604547000,
              modifyTime: 1579604547000
            },
            {
              id: 30,
              pubDate: 1579601713000,
              pubDateStr: "2天前",
              title: "天津确诊2例新型冠状病毒感染肺炎病例",
              summary:
                "目前，两名患者生命体征平稳，其在津密切接触者正在接受医学观察。",
              infoSource: "人民日报微博",
              sourceUrl: "https://m.weibo.cn/2803301701/4463235401268457",
              provinceId: "12",
              provinceName: "天津市",
              createTime: 1579604473000,
              modifyTime: 1579604473000
            },
            {
              id: 29,
              pubDate: 1579599048000,
              pubDateStr: "2天前",
              title: "浙江省确认首例输入性新型冠状病毒感染的肺炎确诊病例",
              summary:
                "1月21日，该患者经国家卫生健康委疫情领导小组下设的诊断组专家评估确认为新型冠状病毒感染的肺炎确诊病例。现患者病情稳定，其密切接触者均在医学观察中。",
              infoSource: "健康浙江",
              sourceUrl: "https://mp.weixin.qq.com/s/rQalqPahvPjdOw6uA1gRuA",
              provinceId: "33",
              provinceName: "浙江省",
              createTime: 1579600281000,
              modifyTime: 1579600281000
            },
            {
              id: 28,
              pubDate: 1579597200000,
              pubDateStr: "2天前",
              title: "2020年1月21日新型冠状病毒感染的肺炎疫情情况",
              summary:
                "截至1月20日24时，国家卫生健康委收到国内4省（区、市）累计报告新型冠状病毒感染的肺炎确诊病例291例（湖北省270例，北京市5例，广东省14例，上海市2例）；14省（区、市）累计报告疑似病例54例（湖北省11例，广东省7例，四川省3例，云南省1例，上海市7例，广西壮族自治区1例，山东省1例，吉林省1例，安徽省1例，浙江省16例，江西省2例，海南省1例，贵州省1例，宁夏回族自治区1例）。",
              infoSource: "央视新闻",
              sourceUrl:
                "https://news.sina.cn/gn/2020-01-21/detail-iihnzahk5604684.d.html?cre=tianyi&mod=whome&loc=3&r=82&rfunc=91&tj=cx_wap_whome&tr=82&wm=4007&vt=4&pos=108&his=0",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579597557000,
              modifyTime: 1579597557000
            },
            {
              id: 27,
              pubDate: 1579594555000,
              pubDateStr: "2天前",
              title: "大连发现 1 例疑似新型冠状病毒肺炎病例",
              summary:
                "据大连市卫健委，1月17日，大连市发现1例武汉来连并出现发热等呼吸道症状患者，疑似新型冠状病毒肺炎病例。目前，该患者在大连市定点医疗机构隔离治疗，病情稳定。",
              infoSource: "央视新闻",
              sourceUrl:
                "https://m.weibo.cn/status/4463195500648886?display=0&retcode=6102",
              provinceId: "21",
              provinceName: "辽宁省",
              createTime: 1579596205000,
              modifyTime: 1579596205000
            },
            {
              id: 25,
              pubDate: 1579588478000,
              pubDateStr: "2天前",
              title: "贵阳市发现一例疑似新型冠状病毒感染肺炎病例",
              summary:
                "1 月 21 日，贵阳市发现 1 例疑似新型冠状病毒感染患者。该患者 1 月 12 日从武汉返回贵阳，1 月 21 日凌晨，省疾控中心对该患者送检样本的病毒实验室检测显示为新型冠状病毒核酸阳性。",
              infoSource: "贵阳市卫生健康局",
              sourceUrl:
                "http://wsjkj.guiyang.gov.cn/tzgg/202001/t20200121_44328899.html",
              provinceId: "52",
              provinceName: "贵州省",
              createTime: 1579588536000,
              modifyTime: 1579588536000
            },
            {
              id: 26,
              pubDate: 1579588140000,
              pubDateStr: "2天前",
              title: "武汉实施进出武汉人员管控",
              summary:
                "为坚决遏制新型冠状病毒感染引起的肺炎疫情扩散，武汉市对进出武汉人员加强管控。武汉市旅游团队不组团外出，公安交管部门对进出武汉的私家车辆进行抽检，检查后备箱是否携带活禽、野生动物等。",
              infoSource: "人民日报",
              sourceUrl: "https://m.weibo.cn/2803301701/4463178593103691",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579592064000,
              modifyTime: 1579592064000
            },
            {
              id: 23,
              pubDate: 1579566420000,
              pubDateStr: "2天前",
              title: "新型冠状病毒感染的肺炎纳入法定传染病管理",
              summary:
                "报国务院批准同意，国家卫生健康委决定将新型冠状病毒感染的肺炎纳入法定传染病乙类管理，采取甲类传染病的预防、控制措施。",
              infoSource: "国家卫健委官方微博",
              sourceUrl: "https://m.weibo.cn/2834480301/4463087468076122",
              provinceId: "31",
              provinceName: "上海市",
              createTime: 1579567163000,
              modifyTime: 1579567163000
            },
            {
              id: 20,
              pubDate: 1579542300000,
              pubDateStr: "2天前",
              title: "武汉 15 名医务人员感染新型冠状病毒",
              summary:
                "武汉市共有 15 名医务人员确诊为新型冠状病毒，另有 1 名为疑似病例。16 例患者中，危重症 1 例，其余病情稳定，均已隔离治疗。",
              infoSource: "武汉市卫健委官方微博",
              sourceUrl: "https://m.weibo.cn/7344184293/4462986360502253",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579492818000,
              modifyTime: 1579492818000
            },
            {
              id: 24,
              pubDate: 1579528561000,
              pubDateStr: "3天前",
              title: "钟南山肯定新型冠状病毒肺炎人传人",
              summary:
                "钟南山：根据目前的资料，新型冠状病毒肺炎是肯定的人传人，在广东有 2 个病例，没去过武汉，但家人去了武汉后染上了新型冠状病毒肺炎，现在可以说，肯定的，有人传人现象。",
              infoSource: "央视新闻",
              sourceUrl: "https://m.weibo.cn/2656274875/4462928671836931",
              provinceId: "11",
              provinceName: "北京市",
              createTime: 1579573904000,
              modifyTime: 1579573904000
            },
            {
              id: 19,
              pubDate: 1579522200000,
              pubDateStr: "3天前",
              title: "广东省确认新增 13 例新型冠状病毒感染的肺炎确诊病例",
              summary:
                "新增病例分布如下：深圳8例、珠海3例、湛江、惠州各1例，均收治在当地定点医疗机构隔离治疗。其中，男性 8 例、女性 5 例；60 岁以上老人 8 例，青壮年 4 例，10 岁儿童 1 例。",
              infoSource: "广东省卫健委官方微博",
              sourceUrl:
                "https://weibo.com/1962787713/IqomkCWan?from=page_1001061962787713_profile&wvr=6&mod=weibotime",
              provinceId: "44",
              provinceName: "广东省",
              createTime: 1579492817000,
              modifyTime: 1579492817000
            },
            {
              id: 18,
              pubDate: 1579521360000,
              pubDateStr: "3天前",
              title: "国家卫健委确认上海首例新型冠状病毒感染的肺炎确诊病例",
              summary:
                "1 月 20 日，经国家卫健委疫情应对处置领导小组的专家评估确认，该病例为新型冠状病毒感染的肺炎确诊病例。现患者体温正常，生命体征平稳，其 2 名在沪密切接触者正在医学观察。",
              infoSource: "上海市卫健委官方微博",
              sourceUrl:
                "https://weibo.com/2372649470/IqogQhgfa?from=page_1001062372649470_profile&wvr=6&mod=weibotime",
              provinceId: "31",
              provinceName: "上海市",
              createTime: 1579492816000,
              modifyTime: 1579492816000
            },
            {
              id: 16,
              pubDate: 1579518817000,
              pubDateStr: "3天前",
              title: "武汉市设置发热门诊医疗机构和定点救治医疗机构名单",
              summary:
                "全市发热门诊 61 家、全市定点医疗机构 9 家、省市联合医疗救治专家 25 人。",
              infoSource: "武汉市卫健委",
              sourceUrl:
                "http://wjw.wuhan.gov.cn/front/web/showDetail/2020012009078",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579492814000,
              modifyTime: 1579492814000
            },
            {
              id: 14,
              pubDate: 1579487760000,
              pubDateStr: "3天前",
              title: "深圳市确诊 1 例新型冠状病毒感染的肺炎病例",
              summary:
                "19 日，国家卫健委确认深圳首例病例。现医院组织全力救治，患者病情稳定。另有 8 例观察病例在定点医院隔离治疗。",
              infoSource: "深圳市卫健委",
              sourceUrl:
                "http://wjw.sz.gov.cn/wzx/202001/t20200120_18987787.htm",
              provinceId: "44",
              provinceName: "广东省",
              createTime: 1579492812000,
              modifyTime: 1579492812000
            },
            {
              id: 13,
              pubDate: 1579485960000,
              pubDateStr: "3天前",
              title: "浙江省发现 5 例疑似新型冠状病毒感染的肺炎病例",
              summary:
                "17 日以来，浙江省温州、舟山、台州、杭州陆续发现 5 例武汉来浙并出现发热等呼吸道症状患者，目前病情稳定，密切接触者已实行医学观察。",
              infoSource: "浙江省卫健委",
              sourceUrl:
                "http://www.zjwjw.gov.cn/art/2020/1/20/art_1202101_41763414.html",
              provinceId: "33",
              provinceName: "浙江省",
              createTime: 1579492811000,
              modifyTime: 1579492811000
            },
            {
              id: 15,
              pubDate: 1579459440000,
              pubDateStr: "3天前",
              title: "北京大兴区确诊 2 例新型冠状病毒感染的肺炎病例",
              summary:
                "大兴区医疗机构接诊的两名有武汉旅行史的发热患者，根据临床症状和流行病学调查，经疾病预防控制中心检测及专家组评估，确认为新型冠状病毒感染的肺炎病例。",
              infoSource: "北京市大兴区卫健委",
              sourceUrl:
                "https://weibo.com/2703012010/IqhwfsbDU?from=page_1001062703012010_profile&wvr=6&mod=weibotime&type=comment",
              provinceId: "11",
              provinceName: "北京市",
              createTime: 1579492813000,
              modifyTime: 1579492813000
            },
            {
              id: 12,
              pubDate: 1579459360000,
              pubDateStr: "3天前",
              title: "武汉 18 日新增病例 59 例，19 日新增病例 77 例",
              summary:
                "18 日，治愈出院 5 例，新增死亡 1 例；19 日，治愈出院 1 例。截至 19 日 22 时，武汉市累计报告新型冠状病毒感染的肺炎病例 198 例，已治愈出院 25 例，死亡 3 例。",
              infoSource: "武汉市卫健委",
              sourceUrl:
                "http://wjw.wuhan.gov.cn/front/web/showDetail/2020012009077",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579492810000,
              modifyTime: 1579492810000
            },
            {
              id: 17,
              pubDate: 1579449600000,
              pubDateStr: "4天前",
              title: "境内累计报告新型冠状病毒感染的肺炎病例 224 例",
              summary:
                "截至 1 月 20 日 18 时，境内累计报告新型冠状病毒感染肺炎确诊 217 例（武汉市 198 例，北京市 5 例，广东省 14 例）；疑似病例 7 例（四川省 2 例，云南省 1 例，上海市 2 例，广西壮族自治区 1 例，山东省 1 例）。",
              infoSource: "国家卫健委",
              sourceUrl:
                "http://www.nhc.gov.cn/wjw/xwdt/202001/6be45fe493804bb6b96a3ed6c92ddb0f.shtml",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579492815000,
              modifyTime: 1579492815000
            },
            {
              id: 11,
              pubDate: 1579365814000,
              pubDateStr: "4天前",
              title: "武汉 17 日新增 17 例新型冠状病毒感染的肺炎病例",
              summary:
                "治愈出院 4 例，无新增死亡病例。累计报告新型冠状病毒感染的肺炎病例 62 例，已治愈出院 19 例，在治重症 8 例，死亡 2 例，其余患者病情稳定",
              infoSource: "武汉市卫健委",
              sourceUrl:
                "http://wjw.wuhan.gov.cn/front/web/showDetail/2020011909074",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579492809000,
              modifyTime: 1579492809000
            },
            {
              id: 10,
              pubDate: 1579277455000,
              pubDateStr: "6天前",
              title: "武汉 16 日新增 4 例新型冠状病毒感染的肺炎病例",
              summary:
                "治愈出院 3 例，无新增死亡病例。累计报告新型冠状病毒感染的肺炎病例 45 例，已治愈出院 15 例，在治重症 5 例，死亡 2 例，其余患者病情稳定。",
              infoSource: "武汉市卫健委",
              sourceUrl:
                "http://wjw.wuhan.gov.cn/front/web/showDetail/2020011809064",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579492808000,
              modifyTime: 1579492808000
            },
            {
              id: 35,
              pubDate: 1579253586000,
              pubDateStr: "6天前",
              title: "【#浙江确诊5例新型冠状病毒肺炎#】",
              summary:
                "今天，国家卫健委确认#浙江确诊首例新型冠状病毒肺炎#。患者为男性，46岁，长期居住武汉市。1月3日自武汉自驾前往温州，1月4日出现发热症状遂就诊，于1月17日在温州定点医院进行隔离治疗。现患者病情稳定，其密切接触者均在医学观察中。中午12时，除首例确诊病例外，经省诊断专家组确诊新型冠状病毒感染的肺炎病例4例，累计报告新型冠状病毒感染的肺炎确诊病例5例，其中：杭州1例、温州2例、舟山1例、台州1例",
              infoSource: "央视新闻微博",
              sourceUrl: "https://m.weibo.cn/2656274875/4463224931926244",
              provinceId: "33",
              provinceName: "浙江省",
              createTime: 1579607577000,
              modifyTime: 1579607577000
            },
            {
              id: 9,
              pubDate: 1579190145000,
              pubDateStr: "20-01-16 23:55",
              title: "武汉 15 日无新增新型冠状病毒感染的肺炎病例",
              summary:
                "治愈出院 5 例，新增死亡病例 1 例。累计报告新型冠状病毒感染的肺炎病例 41 例，已治愈出院 12 例，在治重症 5 例，死亡 2 例，其余患者病情稳定。",
              infoSource: "武汉市卫健委",
              sourceUrl:
                "http://wjw.wuhan.gov.cn/front/web/showDetail/2020011609057",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579492807000,
              modifyTime: 1579492807000
            },
            {
              id: 8,
              pubDate: 1579095552000,
              pubDateStr: "20-01-15 21:39",
              title: "武汉 14 日无新增新型冠状病毒感染的肺炎病例",
              summary:
                "截至目前，武汉市累计报告新型冠状病毒感染的肺炎病例 41 例，已治愈出院 7 例，在治重症 6 例，死亡 1 例，其余患者病情稳定，患者均在武汉市定点医疗机构接受隔离治疗。",
              infoSource: "武汉市卫健委",
              sourceUrl:
                "http://wjw.wuhan.gov.cn/front/web/showDetail/2020011509046",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579492806000,
              modifyTime: 1579492806000
            },
            {
              id: 7,
              pubDate: 1579010736000,
              pubDateStr: "20-01-14 22:05",
              title: "武汉 13 日无新增新型冠状病毒感染的肺炎病例",
              summary:
                "截至目前，武汉市累计报告新型冠状病毒感染的肺炎病例 41 例，已治愈出院 7 例，在治重症 6 例，死亡 1 例，其余患者病情稳定，患者均在武汉市定点医疗机构接受隔离治疗。",
              infoSource: "武汉市卫健委",
              sourceUrl:
                "http://wjw.wuhan.gov.cn/front/web/showDetail/2020011409039",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579492805000,
              modifyTime: 1579492805000
            },
            {
              id: 6,
              pubDate: 1578913219000,
              pubDateStr: "20-01-13 19:00",
              title: "武汉 12 日无新增新型冠状病毒感染的肺炎病例",
              summary:
                "截至目前，武汉市累计报告新型冠状病毒感染的肺炎病例 41 例，已治愈出院 7 例，在治重症 6 例，死亡 1 例，其余患者病情稳定，患者均在武汉市定点医疗机构接受隔离治疗。",
              infoSource: "武汉市卫健委",
              sourceUrl:
                "http://wjw.wuhan.gov.cn/front/web/showDetail/2020011309038",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579492804000,
              modifyTime: 1579492804000
            },
            {
              id: 5,
              pubDate: 1578831013000,
              pubDateStr: "20-01-12 20:10",
              title: "武汉 11 日无新增新型冠状病毒感染的肺炎病例",
              summary:
                "累计报告新型冠状病毒感染的肺炎病例 41 例，已治愈出院 6 例，在治重症7例，死亡1例，其余患者病情稳定，患者均在武汉市定点医疗机构接受隔离治疗。",
              infoSource: "武汉市卫健委",
              sourceUrl:
                "http://wjw.wuhan.gov.cn/front/web/showDetail/2020011209037",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579492803000,
              modifyTime: 1579492803000
            },
            {
              id: 4,
              pubDate: 1578697451000,
              pubDateStr: "20-01-11 07:04",
              title: "武汉初步诊断有新型冠状病毒感染的肺炎病例 41 例",
              summary:
                "其中已出院 2 例、重症 7 例、死亡 1 例，其余患者病情稳定。所有密切接触者 739 人，其中医务人员 419 人，均已接受医学观察，没有发现相关病例。",
              infoSource: "武汉市卫健委",
              sourceUrl:
                "http://wjw.wuhan.gov.cn/front/web/showDetail/2020011109035",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579492802000,
              modifyTime: 1579492802000
            },
            {
              id: 3,
              pubDate: 1578227604000,
              pubDateStr: "20-01-05 20:33",
              title: "武汉共发现病毒性肺炎诊断患者 59 例",
              summary:
                "截止 8 时，共报告符合不明原因的病毒性肺炎诊断患者 59 例，其中重症患者 7 例，其余患者生命体征总体稳定，目前所有患者均在武汉市医疗机构接受隔离治疗，无死亡病例。",
              infoSource: "武汉市卫健委",
              sourceUrl:
                "http://wjw.wuhan.gov.cn/front/web/showDetail/2020010509020",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579492801000,
              modifyTime: 1579492801000
            },
            {
              id: 2,
              pubDate: 1578042042000,
              pubDateStr: "20-01-03 17:00",
              title: "武汉共发现病毒性肺炎诊断患者 44 例",
              summary:
                "截止 8 时，共发现符合不明原因的病毒性肺炎诊断患者 44 例，其中重症 11 例，其余患者生命体征总体稳定。目前所有病例均在武汉市医疗机构接受隔离治疗，已经追踪到 121 名密切接触者并行医学观察。",
              infoSource: "武汉市卫健委",
              sourceUrl:
                "http://wjw.wuhan.gov.cn/front/web/showDetail/2020010309017",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579492800000,
              modifyTime: 1579492800000
            },
            {
              id: 1,
              pubDate: 1577770685000,
              pubDateStr: "19-12-31 13:38",
              title: "武汉发现 27 例肺炎病例",
              summary:
                "近期部分医疗机构发现接诊的多例肺炎病例与华南海鲜城有关联。目前已发现 27 例病例，其中 7 例病情严重，其余病例病情稳定可控，有 2 例病情好转拟于近期出院。",
              infoSource: "武汉市卫健委",
              sourceUrl:
                "http://wjw.wuhan.gov.cn/front/web/showDetail/2019123108989",
              provinceId: "42",
              provinceName: "湖北省",
              createTime: 1579492800000,
              modifyTime: 1579492800000
            }
          ]
        };
      }
      this.loadding = false;

      // axios
      //   .get(`${location.protocol}//wuhanbk.91jkys.com/getdata`)
      //   .then(data => {
      //     this.data = data.data.data;
      //     window.localStorage.setItem("wuhan", JSON.stringify(this.data));
      //     this.loadding = false;
      //   })
      //   .catch(e => {
      //     const oldData = window.localStorage.getItem("wuhan");
      //     if (oldData) {
      //       this.data = JSON.parse(window.localStorage.getItem("wuhan"));
      //       this.loadding = false;
      //     }
      //   });
    }
  }
};
</script>
<style lang="less">
.loading {
  width: 50px;
  padding: 250px 0;
  text-align: center;
  margin: 0 auto;
}
.select {
  padding-top: 50px;
  font-size: 20px;
  position: absolute;
  bottom: 100px;
  left: 50%;
  margin-left: -140px;
  > div {
    height: 48px;
    line-height: 48px;
    border: 1px solid #fff;
    width: 200px;
    display: inline-block;
    font-size: 20px;
    i {
      float: right;
      position: relative;
      top: 10px;
      left: -10px;
      color: #fff !important;
    }
  }
}
.banner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 30px;
  text-align: center;
  height: 100vh;
  color: #fff;
  h2 {
    font-size: 36px;
    padding: 30px 0;
  }
}
.banner-logo {
  width: 100px;
  margin: 50px auto 0;
}
.content--canvas {
  height: 100%;
  position: relative;
  canvas {
    position: static !important;
  }
}
</style>
<style lang="less" scoped>
body {
  -webkit-overflow-scrolling: touch;
}
.section3 {
  background: #000;
}
.section {
  min-height: 100vh;
}
.section1 {
  margin-bottom: 20px;
  overflow: hidden;
}
.header {
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
  padding: 0 20px;
  margin-bottom: 10px;
  > span {
    padding-left: 10px;
    border-left: 2px solid #0199ca;
  }
}
.knowledge {
  padding: 20px;
  p {
    line-height: 24px;
    margin-bottom: 14px;
  }
  a {
    color: #0199ca;
  }
}
.map {
  padding: 20px;
}
.city {
  line-height: 32px;
  font-size: 14px;
}

img {
  max-width: 100%;
  font-size: 0;
}
.goods-wrapper {
  overflow: hidden;
  display: flex;
  justify-content: space-between;
}
.goods {
  width: 50%;
}

.news {
  display: inline-block;
  width: 100%;
  margin-top: 16px;
  vertical-align: top;
  position: relative;
  padding-right: 16px;
  box-sizing: border-box;
}
.news-item {
  display: flex;
  &-left {
    width: 100px;
    flex: none;
    position: relative;
    overflow: hidden;
    transform: translateY(8px);
  }
  &-right {
    flex-grow: 1;
    margin-bottom: 12px;
    padding: 9px 12px;
    background: #fff;
    border-radius: 4px;
    position: relative;
  }
  &-time {
    position: absolute;
    right: 32px;
    font-weight: 500;
    font-size: 12px;
    text-align: right;
    vertical-align: top;
    word-wrap: break-word;
    word-break: break-all;
  }
  &-dot {
    display: inline-block;
    position: absolute;
    left: 76px;
    top: 0;
    width: 12px;
    height: 12px;
    z-index: 2;
  }
  &-line {
    position: absolute;
    top: 10px;
    left: 81px;
    display: inline-block;
    width: 2px;
    height: 999px;
    background: #ebebeb;
  }
  &-title {
    display: -webkit-box;
    max-height: 45px;
    line-height: 23px;
    overflow: hidden;
    font-weight: 600;
    font-size: 16px;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    i {
      display: inline-block;
      width: 28px;
      height: 16px;
      line-height: 16px;
      margin-right: 6px;
      color: #fff;
      font-size: 12px;
      font-style: normal;
      text-align: center;
      background-color: #f74c31;
      border-radius: 2px;
    }
  }
  &-content {
    color: #999;
    font-size: 12px;
    margin-top: 4px;
    line-height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 5;
  }
  &-from {
    margin-top: 4px;
    color: #999;
    font-size: 12px;
    text-align: right;
    bottom: 12px;
    right: 16px;
  }
}
.weizhi {
  color: #999;
  padding: 10px;
}
.h1 {
  font-size: 26px;
  font-weight: bold;
  padding: 30px 0 30px;
  text-align: center;
  color: #fff;
  background: linear-gradient(-60deg, #00d3ea, #0199ca);
  position: relative;
}
.global {
  padding: 20px;
}
.hudong {
  color: #0199ca;
  font-weight: bold;
  font-size: 20px;
  padding: 0px 0 40px;
  line-height: 32px;
}
.txt1 p {
  margin-bottom: 10px;
  color: #333;
  font-weight: bold;
}
.txt2 {
  padding: 10px 0;
  line-height: 24px;
  li {
    margin-bottom: 5px;
  }
  .van-icon {
    margin-right: 5px;
    color: #0199ca;
  }
}
.txt3 {
  color: #999;
  text-align: right;
}
.van-icon {
  color: #0199ca;
}
.logo {
  width: 60px;
  position: absolute;
  right: 10px;
  top: 10px;
}
.section1-img {
  margin: 0;
}
</style>
